import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Box, Switch, Tooltip } from '@mui/material';
import {
  Button,
  Modal,
  Box as MuiBox,
  Typography,
  Fade,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,

} from "@mui/material";
import { ArrowBack, ArrowForward, } from "@mui/icons-material";
import {
  EmojiEvents as TrophyIcon,
  ErrorOutline as ErrorIcon,
  Info as InfoIcon,
  CheckCircle as CheckIcon,
  Schedule as TimeIcon,
  Check as CorrectIcon,
  Close as IncorrectIcon,
  History as HistoryIcon,
  List as ListIcon
} from "@mui/icons-material";
import katex from "katex";
import "katex/dist/katex.min.css";
import sanitizeHtml from "sanitize-html";
import CloseIcon from '@mui/icons-material/Close';
import { useContext } from "react";
import { ThemeContext } from '../context/ThemeContext';

const FIBQuiz = () => {
  const { subfolder_id } = useParams();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [allAnswers, setAllAnswers] = useState([]);
  const [isQuizFinished, setIsQuizFinished] = useState(false);
  const [isLastQuestionSubmitted, setIsLastQuestionSubmitted] = useState(false);
  const [quizId, setQuizId] = useState(null);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [isTimeUpModalOpen, setIsTimeUpModalOpen] = useState(false);
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [isEditableReviewModalOpen, setIsEditableReviewModalOpen] = useState(false);
  const [forceRender, setForceRender] = useState(0);
  const [isStartModalOpen, setIsStartModalOpen] = useState(true);
  const [maxAttempts, setMaxAttempts] = useState("");
  const [selectedAttemptNo, setSelectedAttemptNo] = React.useState(null); // For Results Modal (number)
  const [userAnswer, setUserAnswer] = useState("");
  const [quizMaxAttempts, setQuizMaxAttempts] = useState(null);
  const [passingPercentage, setPassingPercentage] = useState("");
  const [negativeMarking, setNegativeMarking] = useState(false);
  const [attemptCount, setAttemptCount] = useState(0);
  const [currentAttemptNo, setCurrentAttemptNo] = useState(null);
  const [quizStarted, setQuizStarted] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isCloseDialogOpen, setIsCloseDialogOpen] = useState(false);
  const [attempts, setAttempts] = useState([]);
  const [selectedAttempt, setSelectedAttempt] = useState(null);
  const [attemptAnswers, setAttemptAnswers] = useState({});
  const [animateKey, setAnimateKey] = useState(0);
  const [isTimerEnabled, setIsTimerEnabled] = useState(true); // New state for timer toggle
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [quizHistory, setQuizHistory] = useState({}); // Store history by quizId
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false); // New state for history modal
  const [selectedHistoryAttempt, setSelectedHistoryAttempt] = useState(null); // New state for selected history attempt
  const [reviewAnswersFromHistory, setReviewAnswersFromHistory] = useState([]); // Store answers for review from history
  const [isHistoryReviewModalOpen, setIsHistoryReviewModalOpen] = useState(false); // New state for history review modal
  const [quizIds, setQuizIds] = useState([]); // New state for quiz IDs
  const [skippedQuestions, setSkippedQuestions] = useState(new Set());
  const [isQuestionListOpen, setIsQuestionListOpen] = useState(false);
  const [shouldShowStartModal, setShouldShowStartModal] = React.useState(true)
  // New state for no internet popup
  const [isNoInternetModalOpen, setIsNoInternetModalOpen] = useState(false);
  // const { darkMode } = useContext(ThemeContext);
  const { mode, customColors } = useContext(ThemeContext);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [unansweredCount, setUnansweredCount] = useState(0);

  const timerRef = useRef(null);
  const modalRef = useRef(null);
  const reviewModalRef = useRef(null);
  const editableReviewModalRef = useRef(null);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    console.log("isResultModalOpen:", isResultModalOpen);
    console.log("isReviewModalOpen:", isReviewModalOpen);
    console.log("isEditableReviewModalOpen:", isEditableReviewModalOpen);
    console.log("Questions length:", questions.length);
    console.log("Force render count:", forceRender);
    if (isResultModalOpen && modalRef.current) {
      console.log("Result Modal DOM present:", modalRef.current);
    }
    if (isReviewModalOpen && reviewModalRef.current) {
      console.log("Review Modal DOM present:", reviewModalRef.current);
    }
    if (isEditableReviewModalOpen && editableReviewModalRef.current) {
      console.log("Editable Review Modal DOM present:", editableReviewModalRef.current);
    }
  }, [isResultModalOpen, isReviewModalOpen, isEditableReviewModalOpen, questions, forceRender]);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  useEffect(() => {
    if (!quizStarted) return;

    const fetchQuestions = async () => {
      try {
        const token = sessionStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in sessionStorage");
        }

        const folderId = parseInt(subfolder_id, 10);
        if (isNaN(folderId)) {
          throw new Error("Invalid subfolder_id: must be a number");
        }

        const maxAttemptsValue = maxAttempts ? parseInt(maxAttempts, 10) : null;
        const passingPercentageValue = passingPercentage
          ? parseFloat(passingPercentage)
          : 45;

        if (maxAttempts && (isNaN(maxAttemptsValue) || maxAttemptsValue <= 0)) {
          throw new Error("Invalid max attempts: must be a positive number or empty");
        }
        if (isNaN(passingPercentageValue) || passingPercentageValue < 0 || passingPercentageValue > 100) {
          throw new Error("Invalid passing percentage: must be between 0 and 100");
        }

        const quizResponse = await fetch(`${apiUrl}/quiz/`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            folder: folderId,
            passing_percentage: passingPercentageValue,
            max_attempts: maxAttemptsValue,
          }),
        });

        if (!quizResponse.ok) {
          const errorText = await quizResponse.text();
          console.error(
            `Quiz creation failed: Status ${quizResponse.status}, ${errorText}`
          );
          throw new Error(`Failed to create quiz: ${quizResponse.statusText}`);
        }

        const quizData = await quizResponse.json();
        console.log("Quiz creation response:", quizData);
        const fetchedQuizId = quizData.id || quizData.quiz_id;
        if (!fetchedQuizId) {
          throw new Error("No quiz_id found in quiz creation response");
        }
        setQuizId(fetchedQuizId);
        setQuizMaxAttempts(quizData.max_attempts ?? null);

        const questionsResponse = await fetch(
          `${apiUrl}/subfolder/${subfolder_id}/fib/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!questionsResponse.ok) {
          const errorText = await questionsResponse.text();
          console.error(
            `Questions fetch failed: Status ${questionsResponse.status}, ${errorText}`
          );
          throw new Error(
            `Failed to fetch questions: ${questionsResponse.statusText}`
          );
        }

        const questionsData = await questionsResponse.json();
        console.log(
          "Raw questions response from /subfolder/fib/:",
          JSON.stringify(questionsData, null, 2)
        );

        const questionArray = Array.isArray(questionsData)
          ? questionsData
          : questionsData.questions || [];
        if (!Array.isArray(questionArray)) {
          console.error("Questions response is not an array:", questionsData);
          throw new Error("No valid questions found in response");
        }

        const fetchedQuestions = questionArray
          .map((item) => {
            console.log(
              `Fields for question ID ${item.id || item.question_id}:`,
              Object.keys(item)
            );

            const answer =
              item.answers ||
              item.correct_answer ||
              item.correctAnswer ||
              item.answer ||
              item.solution ||
              "Answer not available";

            const questionObj = {
              id: item.id || item.question_id,
              question:
                item.statement ||
                item.question ||
                item.text ||
                "No question provided",
              answer: answer,
              explanation: item.explanation || item.description || "",
              question_type: item.question_type || "FIB",
              blankCount: (item.statement?.match(/\[BLANK\]/g) || []).length,
            };
            console.log("Mapped question:", {
              id: questionObj.id,
              question: questionObj.question,
              answer: questionObj.answer,
              type: questionObj.question_type,
              explanation: questionObj.explanation,
              blankCount: questionObj.blankCount,
            });
            return questionObj;
          })
          .filter((item) => item && item.question_type === "FIB" && item.id && item.blankCount > 0);

        console.log(
          "Filtered FIB questions with IDs and blanks:",
          fetchedQuestions.map((q) => ({
            id: q.id,
            question: q.question,
            answer: q.answer,
            blankCount: q.blankCount,
          }))
        );
        if (fetchedQuestions.length === 0) {
          console.warn("No FIB questions with valid IDs and blanks found");
          alert("No fill-in-the-blanks questions available for this quiz.");
          return;
        }

        const shuffledQuestions = shuffleArray(fetchedQuestions);
        console.log(
          "Shuffled questions:",
          shuffledQuestions.map((q) => ({
            id: q.id,
            question: q.question,
            blankCount: q.blankCount,
          }))
        );

        setQuestions(shuffledQuestions);
        setUserAnswers(new Array(shuffledQuestions[0]?.blankCount || 0).fill(""));
        setAllAnswers(new Array(shuffledQuestions.length).fill(""));
        setTimeLeft(shuffledQuestions.length * 30);
      } catch (error) {
        console.error("Error fetching questions:", error.message);
        alert("Failed to load quiz questions. Please try again.");
      }
    };

    fetchQuestions();
  }, [subfolder_id, quizStarted, maxAttempts, passingPercentage]);

  useEffect(() => {
    if (isQuizFinished || timeLeft === null) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleTimeUp();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isQuizFinished, timeLeft]);

  useEffect(() => {
    const savedAnswer = allAnswers[currentQuestionIndex] || "";
    const answerArray = savedAnswer ? savedAnswer.split(",") : new Array(questions[currentQuestionIndex]?.blankCount || 0).fill("");
    setUserAnswers(answerArray);
  }, [currentQuestionIndex, allAnswers, questions]);


  const handleAnswerChange = (blankIndex, value) => {
    const newAnswers = [...userAnswers];
    newAnswers[blankIndex] = value;
    setUserAnswers(newAnswers);

    // Update allAnswers immediately to mark the question as attempted
    const newAllAnswers = [...allAnswers];
    newAllAnswers[currentQuestionIndex] = newAnswers.join(",");
    setAllAnswers(newAllAnswers);

    // Remove from skippedQuestions if the user enters an answer
    if (newAnswers.some((ans) => ans.trim() !== "")) {
      setSkippedQuestions((prev) => {
        const newSet = new Set(prev);
        newSet.delete(currentQuestionIndex);
        return newSet;
      });
    }

    console.log("Updated answers for question", currentQuestionIndex + 1, ":", newAnswers);
  };

  const handleSubmitAnswer = () => {
    console.log(
      "Submitting answers for question",
      currentQuestionIndex + 1,
      ":",
      userAnswers
    );
    const newAnswers = [...allAnswers];
    newAnswers[currentQuestionIndex] = userAnswers.join(",");
    console.log("Prepared answers:", newAnswers);
    setAllAnswers(newAnswers);
    if (currentQuestionIndex + 1 < questions.length) {
      setUserAnswers(new Array(questions[currentQuestionIndex + 1].blankCount).fill(""));
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      // Cycle back to the first question
      setUserAnswers(new Array(questions[0].blankCount).fill(""));
      setCurrentQuestionIndex(0);
    }
  };

  useEffect(() => {
    const savedAnswer = allAnswers[currentQuestionIndex] || "";
    setUserAnswer(savedAnswer);
  }, [currentQuestionIndex, allAnswers]);

  // Handle Previous Question
  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      const newAnswers = [...allAnswers];
      newAnswers[currentQuestionIndex] = userAnswer;
      setAllAnswers(newAnswers);
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      console.log("Navigated to previous question:", currentQuestionIndex);
    }
  };

  // Handle Next Question
  const handleNextQuestion = () => {
    if (userAnswers.some((ans) => ans.trim() !== "") && currentQuestionIndex + 1 < questions.length) {
      const newAnswers = [...allAnswers];
      newAnswers[currentQuestionIndex] = userAnswers.join(",");
      setAllAnswers(newAnswers);
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setUserAnswers(new Array(questions[currentQuestionIndex + 1].blankCount).fill(""));
      console.log("Navigated to next question:", currentQuestionIndex + 2);
    }
  };

  // Handle Skip Question
  const handleSkipQuestion = () => {
    const newAnswers = [...allAnswers];
    newAnswers[currentQuestionIndex] = "";
    setAllAnswers(newAnswers);
    setSkippedQuestions((prev) => new Set(prev).add(currentQuestionIndex));

    if (currentQuestionIndex + 1 < questions.length) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setUserAnswers(new Array(questions[currentQuestionIndex + 1].blankCount).fill(""));
      console.log("Skipped question:", currentQuestionIndex + 1);
    } else {
      setIsEditableReviewModalOpen(true);
      console.log("Skipped last question:", currentQuestionIndex + 1);
    }
  };

  // Handler to toggle question list visibility
  const toggleQuestionList = () => {
    setIsQuestionListOpen((prev) => !prev);
  };

  // Handler to navigate to a specific question
  const handleQuestionSelect = (index) => {
    const newAnswers = [...allAnswers];
    newAnswers[currentQuestionIndex] = userAnswers.join(",");
    setAllAnswers(newAnswers);
    setCurrentQuestionIndex(index);
    const selectedAnswer = allAnswers[index] || "";
    const answerArray = selectedAnswer ? selectedAnswer.split(",") : new Array(questions[index]?.blankCount || 0).fill("");
    setUserAnswers(answerArray);
    setIsQuestionListOpen(false);
    console.log("Navigated to question:", index + 1);
  };

 const handleFinishQuiz = () => {
    const newAnswers = [...allAnswers];
    newAnswers[currentQuestionIndex] = userAnswer;
    setAllAnswers(newAnswers);

    // Check unanswered questions
    const unanswered = newAnswers.filter((ans) => ans === null || ans === "").length;

    if (unanswered === 0) {
      // ✅ All questions attempted → directly submit
      submitQuizResults(newAnswers);
      setIsLastQuestionSubmitted(false);
    } else {
      // ❌ Some unanswered → show dialog
      setUnansweredCount(unanswered);
      setOpenConfirm(true);
    }
  };
  // Handle Finish Quiz
  const handleConfirmSubmit = () => {
    const newAnswers = [...allAnswers];
    newAnswers[currentQuestionIndex] = userAnswer;
    setAllAnswers(newAnswers);

    submitQuizResults(newAnswers);
    setIsLastQuestionSubmitted(false);

    setOpenConfirm(false);
  };

  const handleReviewAnswers = () => {
    const newAnswers = [...allAnswers];
    newAnswers[currentQuestionIndex] = userAnswers.join(",");
    setAllAnswers(newAnswers);
    setIsEditableReviewModalOpen(true);
  };

  const handleSaveAndFinish = () => {
    submitQuizResults(allAnswers);
    setIsEditableReviewModalOpen(false);
  };

  const handleAnswerEdit = (questionIndex, blankIndex, value) => {
    const answerArray = allAnswers[questionIndex] ? allAnswers[questionIndex].split(",") : new Array(questions[questionIndex].blankCount).fill("");
    answerArray[blankIndex] = value;
    const newAnswers = [...allAnswers];
    newAnswers[questionIndex] = answerArray.join(",");
    setAllAnswers(newAnswers);
    console.log("Edited answer for question", questionIndex + 1, ", blank", blankIndex + 1, ":", value);
  };

  // Load quiz history from localStorage when component mounts or quizId changes
  useEffect(() => {
    try {
      // const storedHistory = localStorage.getItem('quizHistory');
      const storedQuizIds = localStorage.getItem('quizIds');
      const storedQuizTypes = localStorage.getItem('quizTypes'); // New: Store quiz type mapping
      if (storedQuizIds) {
        const allQuizIds = JSON.parse(storedQuizIds);
        const quizTypes = storedQuizTypes ? JSON.parse(storedQuizTypes) : {};
        // Filter only FIB quiz IDs
        const fibQuizIds = allQuizIds.filter(qId => quizTypes[qId] === 'FIB');
        setQuizIds(fibQuizIds);
      }
      // if (storedHistory) {
      //   const history = JSON.parse(storedHistory);
      //   // Filter history to include only FIB quizzes
      //   const fibHistory = Object.keys(history).reduce((acc, qId) => {
      //     if (history[qId].some(attempt => attempt.quiz_type === 'FIB')) {
      //       acc[qId] = history[qId].filter(attempt => attempt.quiz_type === 'FIB');
      //     }
      //     return acc;
      //   }, {});
      //   setQuizHistory(fibHistory);
      // }
    } catch (error) {
      console.error('Error loading quiz history or IDs from localStorage:', error);
      setQuizHistory({});
      setQuizIds([]);
    }
  }, []);

  // Modified function to save quizId with type
  const saveQuizId = (qId) => {
    setQuizIds((prev) => {
      const updatedQuizIds = prev.includes(qId) ? prev : [...prev, qId];
      try {
        localStorage.setItem('quizIds', JSON.stringify(updatedQuizIds));
        // Save quiz type
        const quizTypes = JSON.parse(localStorage.getItem('quizTypes') || '{}');
        quizTypes[qId] = 'FIB';
        localStorage.setItem('quizTypes', JSON.stringify(quizTypes));
        console.log('Saved quizIds:', updatedQuizIds, 'with type FIB');
      } catch (error) {
        console.error('Error saving quiz IDs or types to localStorage:', error);
      }
      return updatedQuizIds;
    });
  };

  // Cache helper functions
  const cacheResponse = async (url, response) => {
    try {
      const cache = await caches.open('quiz-cache');
      const clonedResponse = response.clone();
      await cache.put(url, clonedResponse);
      console.log(`Cached response for ${url}`);
    } catch (error) {
      console.error('Error caching response:', error);
    }
  };

  const getCachedResponse = async (url) => {
    try {
      const cache = await caches.open('quiz-cache');
      const response = await cache.match(url);
      if (response) {
        const data = await response.json();
        console.log(`Retrieved cached response for ${url}`);
        return data;
      }
      return null;
    } catch (error) {
      console.error('Error retrieving cached response:', error);
      return null;
    }
  };

  const cacheAnswers = async (quizId, attemptNo, answers) => {
    try {
      const cache = await caches.open('quiz-answers-cache');
      const cacheKey = `quiz-${quizId}-attempt-${attemptNo}-answers`;
      await cache.put(
        cacheKey,
        new Response(JSON.stringify(answers), {
          headers: { 'Content-Type': 'application/json' },
        })
      );
      console.log(`Cached answers for ${cacheKey}`);
    } catch (error) {
      console.error('Error caching answers:', error);
    }
  };

  const getCachedAnswers = async (quizId, attemptNo) => {
    try {
      const cache = await caches.open('quiz-answers-cache');
      const cacheKey = `quiz-${quizId}-attempt-${attemptNo}-answers`;
      const response = await cache.match(cacheKey);
      if (response) {
        const answers = await response.json();
        console.log(`Retrieved cached answers for ${cacheKey}`);
        return answers;
      }
      return null;
    } catch (error) {
      console.error('Error retrieving cached answers:', error);
      return null;
    }
  };

  // Modified submitQuizResults function
  const submitQuizResults = async (answers = allAnswers) => {
    if (!quizId) {
      setError("Quiz ID is missing. Cannot submit results.");
      return;
    }

    // Check for internet connectivity
    if (!navigator.onLine) {
      setIsNoInternetModalOpen(true);
      // Cache answers for offline submission
      const attemptNo = attemptCount + 1;
      await cacheAnswers(quizId, attemptNo, answers);
      return;
    }

    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) throw new Error("No auth token found");

      const submitUrl = `${apiUrl}/quiz/${quizId}/submit/`;
      const payload = {
        answers: answers.map((answer, index) => ({
          question_id: Number(questions[index].id),
          selected_answer: answer ? answer.trim() : "",
        })),
      };

      // Check cache first
      let resultData = await getCachedResponse(submitUrl);
      let response = null;

      if (!resultData) {
        // No cached response, make API call
        response = await fetch(submitUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`Failed to submit quiz: ${response.statusText}`);

        resultData = await response.json();

        // Cache the response
        await cacheResponse(submitUrl, response);
      }

      const attemptNo = resultData.attempt_no || resultData.attempt_number || resultData.id || attemptCount + 1;
      setCurrentAttemptNo(attemptNo);
      setAttemptCount(attemptNo);
      setAttemptAnswers((prev) => ({
        ...prev,
        [attemptNo]: [...answers],
      }));

      // Cache answers
      await cacheAnswers(quizId, attemptNo, answers);

      let correctAnswers = 0;
      let wrongAnswers = 0;
      const attemptedQuestions = answers.filter((answer) => answer && answer.trim() !== "").length;

      answers.forEach((answer, index) => {
        if (answer && answer.trim() !== "") {
          const isCorrect = answer.trim().toLowerCase() === questions[index].answer.trim().toLowerCase();
          if (isCorrect) {
            correctAnswers += 1;
          } else {
            wrongAnswers += 1;
          }
        }
      });

      const totalFIBQuestions = questions.length;
      let finalScore = negativeMarking ? correctAnswers - wrongAnswers : correctAnswers;
      let scorePercentage = totalFIBQuestions > 0 ? (finalScore / totalFIBQuestions) * 100 : 0;

      const passingPercentageValue = resultData.passing_percentage ?? passingPercentage ?? 45;
      const result = scorePercentage >= passingPercentageValue ? "Passed" : "Failed";

      const newResults = {
        final_score: finalScore,
        score_percentage: scorePercentage,
        result: result,
        attempted_questions: attemptedQuestions,
        attempts_used: attemptNo,
        correct_answers: correctAnswers,
        wrong_answers: wrongAnswers,
        started_at: resultData.started_at ?? "N/A",
        ended_at: resultData.ended_at ?? "N/A",
        quiz_status: resultData.quiz_status ?? "N/A",
        total_questions: totalFIBQuestions,
        passing_percentage: passingPercentageValue,
      };

      // Save quizId with FIB type
      saveQuizId(quizId);

      // setQuizHistory((prev) => {
      //   const existingAttempts = prev[quizId] || [];
      //   const attemptExists = existingAttempts.some(
      //     (attempt) => attempt.attempt_no === attemptNo
      //   );
      //   if (attemptExists) {
      //     console.warn(`Attempt ${attemptNo} already exists for quiz ${quizId}`);
      //     return prev;
      //   }
      //   const newAttempt = {
      //     attempt_no: attemptNo,
      //     quiz_type: 'FIB',
      //     results: newResults,
      //     answers: [...answers],
      //     timestamp: new Date().toISOString(),
      //   };
      //   const updatedHistory = {
      //     ...prev,
      //     [quizId]: [...existingAttempts, newAttempt],
      //   };
      //   try {
      //     localStorage.setItem('quizHistory', JSON.stringify(updatedHistory));
      //     console.log('Saved FIB quizHistory:', updatedHistory);
      //   } catch (error) {
      //     console.error('Error saving quiz history to localStorage:', error);
      //   }
      //   return updatedHistory;
      // });

      setResults(newResults);
      setIsQuizFinished(true);
      setError(null);
    } catch (error) {
      setError(`Failed to submit quiz: ${error.message}`);
      setAttemptCount((prev) => prev + 1);
      // Cache answers on error
      await cacheAnswers(quizId, attemptCount + 1, answers);
    }
  };

  const fetchQuizResults = async (quizId) => {
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found");
      }
      const response = await fetch(`${apiUrl}/quiz/${quizId}/result/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        console.warn(`Failed to fetch results for quiz ${quizId}: ${response.statusText}`);
        return [];
      }
      const resultData = await response.json();
      // Validate that the quiz is FIB-specific
      const quizTypes = JSON.parse(localStorage.getItem('quizTypes') || '{}');
      if (quizTypes[quizId] !== 'FIB') {
        console.log(`Quiz ${quizId} is not FIB, skipping results`);
        return [];
      }
      const attempts = Array.isArray(resultData) ? resultData : [resultData];
      const formattedAttempts = attempts.map((result, index) => {
        const attemptNo = result.attempt_no || result.attempt_number || index + 1;
        const answers = result.answers ? result.answers.map((ans) => ans.selected_answer || "") : [];
        return {
          attempt_no: attemptNo,
          quiz_type: 'FIB', // Mark as FIB
          results: {
            final_score: result.final_score ?? 0,
            score_percentage: result.score_percentage ?? (result.score && result.total_questions ? (result.score / result.total_questions) * 100 : 0),
            result: result.result ?? (result.score_percentage >= (result.passing_percentage ?? 45) ? "Passed" : "Failed"),
            attempted_questions: result.attempted_questions ?? answers.filter((a) => a.trim() !== "").length,
            attempts_used: attemptNo,
            correct_answers: result.correct_answers ?? 0,
            wrong_answers: result.wrong_answers ?? 0,
            started_at: result.started_at ?? "N/A",
            ended_at: result.ended_at ?? "N/A",
            quiz_status: result.quiz_status ?? "N/A",
            total_questions: result.total_questions ?? questions.length,
            passing_percentage: result.passing_percentage ?? 45,
          },
          answers,
          timestamp: result.timestamp ?? new Date().toISOString(),
        };
      });
      console.log(`Fetched FIB results for quiz ${quizId}:`, formattedAttempts);
      return formattedAttempts;
    } catch (error) {
      console.error(`Error fetching results for quiz ${quizId}:`, error);
      return [];
    }
  };

  // Modified toggleHistoryDrawer to fetch only FIB quiz results
  // const toggleHistoryDrawer = (open) => async () => {
  //   setIsHistoryOpen(open);
  //   if (open) {
  //     setIsStartModalOpen(false);
  //     setShouldShowStartModal(false);
  //     // Only process FIB quiz IDs
  //     const quizTypes = JSON.parse(localStorage.getItem('quizTypes') || '{}');
  //     const fibQuizIds = quizIds.filter(qId => quizTypes[qId] === 'FIB');
  //     setQuizHistory((prev) => {
  //       const updatedHistory = { ...prev };
  //       const fetchPromises = fibQuizIds.map(async (qId) => {
  //         const results = await fetchQuizResults(qId);
  //         const existingAttempts = updatedHistory[qId] || [];
  //         const newAttempts = results.filter(
  //           (newAttempt) =>
  //             !existingAttempts.some(
  //               (existing) => existing.attempt_no === newAttempt.attempt_no
  //             )
  //         );
  //         updatedHistory[qId] = [...existingAttempts, ...newAttempts];
  //       });
  //       Promise.all(fetchPromises).then(() => {
  //         try {
  //           localStorage.setItem('quizHistory', JSON.stringify(updatedHistory));
  //           console.log('Updated FIB-only quizHistory:', updatedHistory);
  //         } catch (error) {
  //           console.error('Error saving quiz history to localStorage:', error);
  //         }
  //       });
  //       return updatedHistory;
  //     });
  //   } else {
  //     if (!quizStarted && !isQuizFinished) {
  //       setIsStartModalOpen(true);
  //       setShouldShowStartModal(true);
  //     } else {
  //       setIsStartModalOpen(false);
  //       setShouldShowStartModal(false);
  //     }
  //   }
  // };

  // Function to reopen the Start Quiz Modal
  const handleOpenStartModal = () => {
    setIsHistoryOpen(false); // Close the drawer when opening the modal
    setIsStartModalOpen(true);
    setShouldShowStartModal(true);
  };

  // Handle selecting a history attempt
  const handleSelectHistoryAttempt = (qId, attempt) => {
    setSelectedAttempt({ qId, attempt });
    const answers = attempt.answers || [];
    setReviewAnswersFromHistory(answers); // Set answers for review
    console.log("Selected attempt answers:", answers); // Debug log
    setIsHistoryModalOpen(true);
  };

  // Format timestamp for display
  const formatTimestamp = (timestamp) => {
    try {
      const date = new Date(timestamp);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    } catch (error) {
      console.error('Error formatting timestamp:', error);
      return 'N/A';
    }
  };

  // Close history modal
  const handleCloseHistoryModal = () => {
    setIsHistoryModalOpen(false); // Close the History Modal
    setSelectedAttempt(null); // Clear the selected attempt
    // Open the Start Quiz Modal if the quiz hasn't started and isn't finished
    if (!quizStarted && !isQuizFinished) {
    }
  };

  const fetchDetailedResults = async () => {
    if (!quizId) {
      setError("Quiz ID is missing. Cannot fetch results.");
      return null;
    }
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found");
      }
      const response = await fetch(`${apiUrl}/quiz/${quizId}/result/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch detailed results: ${response.statusText}`);
      }
      const resultData = await response.json();
      return resultData;
    } catch (error) {
      setError(`Failed to fetch detailed results: ${error.message}`);
      return null;
    }
  };

  const fetchAvailableAttempts = async () => {
    if (!quizId) {
      setError("Quiz ID is missing. Cannot fetch attempts.");
      return [];
    }
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found");
      }
      const maxAttemptsValue = quizMaxAttempts ?? attemptCount;
      const attemptPromises = [];
      for (let i = 1; i <= maxAttemptsValue; i++) {
        attemptPromises.push(
          fetch(`${apiUrl}/quiz/${quizId}/attempt/${i}/`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }).then(async (response) => {
            if (response.ok) {
              const data = await response.json();
              return { attempt_no: i, data };
            }
            return null;
          })
        );
      }
      const results = await Promise.all(attemptPromises);
      const validAttempts = results
        .filter((result) => result !== null)
        .map((result) => ({
          attempt_no: result.attempt_no,
          data: result.data,
        }));
      return validAttempts;
    } catch (error) {
      setError(`Failed to fetch attempts: ${error.message}`);
      return [];
    }
  };

  const fetchAttemptDetails = async (attemptNo) => {
    if (!quizId || !attemptNo) {
      setError("Quiz ID or attempt number is missing.");
      return null;
    }
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found");
      }
      const response = await fetch(`${apiUrl}/quiz/${quizId}/attempt/${attemptNo}/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch attempt ${attemptNo}: ${response.statusText}`);
      }
      const resultData = await response.json();
      return resultData;
    } catch (error) {
      setError(`Failed to fetch attempt ${attemptNo}: ${error.message}`);
      return null;
    }
  };

  const handleViewResult = async () => {
    const availableAttempts = await fetchAvailableAttempts();
    setAttempts(availableAttempts);

    let resultData = null;
    let selectedAttemptNum = null; // Renamed to avoid confusion
    let attemptSpecificAnswers = [];

    if (availableAttempts.length > 0) {
      const latestAttempt = availableAttempts[availableAttempts.length - 1];
      selectedAttemptNum = latestAttempt.attempt_no;
      setSelectedAttemptNo(selectedAttemptNum); // Set the new state
      resultData = latestAttempt.data;

      attemptSpecificAnswers = attemptAnswers[selectedAttemptNum] || [];
      if (!attemptSpecificAnswers.length) {
        const attemptDetails = await fetchAttemptDetails(selectedAttemptNum);
        attemptSpecificAnswers = attemptDetails?.answers
          ? attemptDetails.answers.map((ans) => ans.selected_answer || "")
          : allAnswers;
      }
    } else {
      resultData = await fetchDetailedResults();
      attemptSpecificAnswers = allAnswers;
    }

    if (!resultData) {
      setIsResultModalOpen(true);
      setForceRender((prev) => prev + 1);
      return;
    }

    let correctAnswers = 0;
    let wrongAnswers = 0;
    const attemptedQuestions = attemptSpecificAnswers.filter(
      (answer) => answer && answer.trim() !== ""
    ).length;

    attemptSpecificAnswers.forEach((answer, index) => {
      if (index >= questions.length) return;
      if (answer && answer.trim() !== "") {
        const isCorrect = answer.trim().toLowerCase() === questions[index].answer.trim().toLowerCase();
        if (isCorrect) {
          correctAnswers += 1;
        } else {
          wrongAnswers += 1;
        }
      }
    });

    const totalFIBQuestions = questions.length;
    let finalScore;
    let scorePercentage;
    if (negativeMarking) {
      finalScore = correctAnswers - wrongAnswers;
    } else {
      finalScore = correctAnswers;
    }
    scorePercentage = totalFIBQuestions > 0 ? (finalScore / totalFIBQuestions) * 100 : 0;

    const passingPercentageValue =
      resultData.passing_percentage ?? results?.passing_percentage ?? passingPercentage ?? 45;
    const result = scorePercentage >= passingPercentageValue ? "Passed" : "Failed";

    const newResults = {
      final_score: finalScore,
      score_percentage: scorePercentage,
      result: result,
      attempted_questions: attemptedQuestions,
      attempts_used: resultData.attempt_no ?? resultData.attempt_number ?? currentAttemptNo ?? attemptCount,
      correct_answers: correctAnswers,
      wrong_answers: wrongAnswers,
      started_at: resultData.started_at ?? results?.started_at ?? "N/A",
      ended_at: resultData.ended_at ?? results?.ended_at ?? "N/A",
      quiz_status: resultData.quiz_status ?? results?.quiz_status ?? "N/A",
      total_questions: totalFIBQuestions,
      passing_percentage: passingPercentageValue,
    };

    setResults(newResults);
    setQuizMaxAttempts(resultData.max_attempts ?? quizMaxAttempts ?? null);
    setIsResultModalOpen(true);
    setForceRender((prev) => prev + 1);
    setAnimateKey((prev) => prev + 1);
    setError(null);
  };

  // Handle Attempt Change
  const handleAttemptChange = async (event) => {
    const attemptNo = event.target.value;
    setSelectedAttemptNo(attemptNo); // Update the new state

    const attemptData = await fetchAttemptDetails(attemptNo);
    if (!attemptData) {
      setForceRender((prev) => prev + 1);
      return;
    }

    let attemptSpecificAnswers = attemptAnswers[attemptNo] || [];
    if (!attemptSpecificAnswers.length) {
      attemptSpecificAnswers = attemptData.answers
        ? attemptData.answers.map((ans) => ans.selected_answer || "")
        : allAnswers;
    }

    let correctAnswers = 0;
    let wrongAnswers = 0;
    const attemptedQuestions = attemptSpecificAnswers.filter(
      (answer) => answer && answer.trim() !== ""
    ).length;

    attemptSpecificAnswers.forEach((answer, index) => {
      if (index >= questions.length) return;
      if (answer && answer.trim() !== "") {
        const isCorrect = answer.trim().toLowerCase() === questions[index].answer.trim().toLowerCase();
        if (isCorrect) {
          correctAnswers += 1;
        } else {
          wrongAnswers += 1;
        }
      }
    });

    const totalFIBQuestions = questions.length;
    let finalScore;
    let scorePercentage;
    if (negativeMarking) {
      finalScore = correctAnswers - wrongAnswers;
    } else {
      finalScore = correctAnswers;
    }
    scorePercentage = totalFIBQuestions > 0 ? (finalScore / totalFIBQuestions) * 100 : 0;

    const passingPercentageValue =
      attemptData.passing_percentage ?? results?.passing_percentage ?? passingPercentage ?? 45;
    const result = scorePercentage >= passingPercentageValue ? "Passed" : "Failed";

    const newResults = {
      final_score: finalScore,
      score_percentage: scorePercentage,
      result: result,
      attempted_questions: attemptedQuestions,
      attempts_used: attemptData.attempt_no ?? attemptData.attempt_number ?? attemptNo,
      correct_answers: correctAnswers,
      wrong_answers: wrongAnswers,
      started_at: attemptData.started_at ?? results?.started_at ?? "N/A",
      ended_at: attemptData.ended_at ?? results?.ended_at ?? "N/A",
      quiz_status: attemptData.quiz_status ?? results?.quiz_status ?? "N/A",
      total_questions: totalFIBQuestions,
      passing_percentage: passingPercentageValue,
    };

    setResults(newResults);
    setQuizMaxAttempts(attemptData.max_attempts ?? quizMaxAttempts ?? null);
    setForceRender((prev) => prev + 1);
    setAnimateKey((prev) => prev + 1);
    setError(null);
  };

  // Open non-editable review modal (for Results Modal)
  const handleOpenReviewModal = () => {
    setIsReviewModalOpen(true);
    setIsResultModalOpen(false);
    setForceRender((prev) => prev + 1);
  };

  // Close non-editable review modal (for Results Modal)
  const handleCloseReviewModal = () => {
    setIsReviewModalOpen(false);
    setIsResultModalOpen(true);
    setForceRender((prev) => prev + 1);
  };

  // New function to open history review modal
  const handleOpenHistoryReviewModal = () => {
    if (!selectedAttempt || !selectedAttempt.attempt.answers || selectedAttempt.attempt.answers.length === 0) {
      console.warn("No valid answers available for review in history");
      setReviewAnswersFromHistory([]); // Ensure empty array if no answers
    }
    setIsHistoryReviewModalOpen(true);
    setIsHistoryModalOpen(false);
    setForceRender((prev) => prev + 1);
  };

  // New function to close history review modal
  const handleCloseHistoryReviewModal = () => {
    setIsHistoryReviewModalOpen(false);
    setIsHistoryModalOpen(true); // Navigate back to History Modal
    setForceRender((prev) => prev + 1);
  };

  const handleCloseEditableReviewModal = () => {
    console.log("Closing editable review modal");
    setIsEditableReviewModalOpen(false);
    setForceRender((prev) => prev + 1);
  };

  const handleCloseResultModal = () => {
    console.log("Closing result modal");
    setIsResultModalOpen(false);
    setCurrentPage(1);
    setForceRender((prev) => prev + 1);
  };

  const handleCloseModal = () => {
    if (!navigator.onLine) {
      // If offline, open no-internet modal, keep timer modal open
      setIsNoInternetModalOpen(true);
      const attemptNo = attemptCount + 1;
      cacheAnswers(quizId, attemptNo, allAnswers);
    } else {
      // If online, close timer modal, submit results, and open result modal
      setIsTimeUpModalOpen(false);
      setIsNoInternetModalOpen(false); // Ensure no-internet modal is closed
      submitQuizResults(allAnswers);
    }
  };
  const handleTimeUp = () => {
    if (!isTimerEnabled) return; // Prevent time-up logic when timer is disabled

    if (userAnswers.some((ans) => ans.trim())) {
      const newAnswers = [...allAnswers];
      newAnswers[currentQuestionIndex] = userAnswers.join(",");
      console.log(
        "Time up - Saved answers:",
        userAnswers,
        "for question",
        currentQuestionIndex + 1
      );
      console.log("All answers:", newAnswers);
      setAllAnswers(newAnswers);
    }
    setIsTimeUpModalOpen(true);
    setUserAnswers(new Array(questions[currentQuestionIndex]?.blankCount || 0).fill(""));
    setIsLastQuestionSubmitted(false);
  };

  // Timer effect (replaces any previous timer logic)
  useEffect(() => {
    if (!isTimerEnabled || isQuizFinished || timeLeft === null || timeLeft === 0) {
      if (timerRef.current) {
        console.log("Clearing timer:", timerRef.current);
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      return;
    }

    console.log("Setting up timer with timeLeft:", timeLeft);
    if (timerRef.current) {
      console.log("Clearing existing timer before new setup:", timerRef.current);
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        console.log("Timer tick, prev timeLeft:", prev);
        if (prev <= 1) {
          console.log("Time up, clearing timer:", timerRef.current);
          clearInterval(timerRef.current);
          timerRef.current = null;
          if (isTimerEnabled) {
            handleTimeUp();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) {
        console.log("Cleanup timer:", timerRef.current);
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isTimerEnabled, isQuizFinished,]); // Include handleTimeUp in dependencies

  // Handle Start Quiz with timer validation
  const handleStartQuiz = () => {
    const maxAttemptsValue = maxAttempts ? parseInt(maxAttempts, 10) : null;
    if (maxAttempts && (isNaN(maxAttemptsValue) || maxAttemptsValue <= 1)) {
      alert("Please enter a valid number of max attempts (positive number or leave blank for unlimited).");
      return;
    }

    if (passingPercentage) {
      const percentage = parseFloat(passingPercentage);
      if (isNaN(percentage) || percentage < 1 || percentage > 100) {
        alert("Please enter a valid passing percentage between 0 and 100.");
        return;
      }
    }

    if (!passingPercentage) {
      setPassingPercentage("35");
    }

    // Set initial time only if timer is enabled
    if (isTimerEnabled) {
      setTimeLeft(questions.length * 30 || 1800); // Default to 30s per question or 30min if no questions yet
    } else {
      setTimeLeft(null); // No timer
    }

    setQuizStarted(true);
    setIsStartModalOpen(false);
  };

  const handleRetryQuiz = () => {
    const max = quizMaxAttempts ?? null;
    if (max !== null && attemptCount >= max) {
      alert("You have reached the maximum number of attempts.");
      return;
    }
    setIsQuizFinished(false);
    setCurrentQuestionIndex(0);
    setUserAnswers(new Array(questions[0]?.blankCount || 0).fill(""));
    setAllAnswers(new Array(questions.length).fill(""));
    setTimeLeft(questions.length * 30);
    setResults(null);
    setError(null);
    setQuizStarted(true);
  };

  const handleCloseQuiz = () => {
    if (isStartModalOpen) {
      setIsStartModalOpen(false);
      navigate(-1);
    } else if (quizStarted && !isQuizFinished) {
      setIsCloseDialogOpen(true);
    } else {
      navigate(-1);
    }
  };

  const handleConfirmClose = () => {
    setIsCloseDialogOpen(false);
    navigate(-1);
  };

  const handleCancelClose = () => {
    setIsCloseDialogOpen(false);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const formatPercentage = (percentage) => {
    if (percentage === null || percentage === undefined) return "N/A";
    const num = Number(percentage);
    if (Number.isInteger(num)) return `${num}%`;
    return `${num.toFixed(num % 1 === 0 ? 0 : num < 10 ? 2 : 1)}%`;
  };

  const resultFields = results
    ? [
      {
        label: "Final Score",
        value: `${results.final_score ?? "N/A"} out of ${results.total_questions}`,
        icon: TrophyIcon,
      },
      {
        label: "Attempts Used",
        value: `${results.attempts_used ?? attemptCount} out of ${quizMaxAttempts !== null ? quizMaxAttempts : maxAttempts === "" ? "Unlimited" : maxAttempts}`,
        icon: InfoIcon,
      },
      {
        label: "Score Percentage",
        value: formatPercentage(results.score_percentage),
        icon: CheckIcon,
      },
      {
        label: "Result",
        value: isQuizFinished
          ? `${results.result ?? "N/A"}${results.passing_percentage ? ` (Passing: ${formatPercentage(results.passing_percentage)})` : ""}`
          : results.result ?? "N/A",
        icon: CheckIcon,
        bgcolor: results.result?.toLowerCase() === "passed" ? "#e8f5e9" : results.result?.toLowerCase() === "failed" ? "#ffebee" : "#f0f4f8",
        color: results.result?.toLowerCase() === "passed" ? "#2e7d32" : results.result?.toLowerCase() === "failed" ? "#d32f2f" : "#01579b",
      },
      {
        label: "Attempted Questions",
        value: `${results.attempted_questions ?? 0} out of ${results.total_questions}`,
        icon: CheckIcon,
      },
      // Additional fields for the Result Modal
      ...(isResultModalOpen
        ? [
          {
            label: "Total Questions",
            value: results.total_questions,
            icon: InfoIcon,
          },
          {
            label: "Correct Answers",
            value: results.correct_answers ?? "N/A",
            icon: CorrectIcon,
          },
          {
            label: "Wrong Answers",
            value: results.wrong_answers ?? "N/A",
            icon: IncorrectIcon,
          },
          {
            label: "Max Attempts",
            value: quizMaxAttempts ?? "Unlimited",
            icon: InfoIcon,
          },
          {
            label: "Quiz Status",
            value: results.quiz_status ?? "N/A",
            icon: InfoIcon,
          },
          {
            label: "Started At",
            value:
              results.started_at && results.started_at !== "N/A"
                ? new Date(results.started_at).toLocaleString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
                : "N/A",
            icon: TimeIcon,
          },
          {
            label: "Ended At",
            value:
              results.ended_at && results.ended_at !== "N/A"
                ? new Date(results.ended_at).toLocaleString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
                : "N/A",
            icon: TimeIcon,
          },
        ]
        : []),
    ]
    : [];

  const itemsPerPage = 6;
  const totalPages = Math.ceil(resultFields.length / itemsPerPage);

  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const renderContent = (html) => {
    if (!html) return null;

    const parts = html.split(/(\$\$.+?\$\$|\$.+?\$)/g);

    return (
      <div>
        {parts.map((part, index) => {
          if (part.startsWith("$$") && part.endsWith("$$")) {
            const latex = part.slice(2, -2);
            try {
              const renderedLatex = katex.renderToString(latex, {
                displayMode: true,
              });
              return (
                <div
                  key={index}
                  dangerouslySetInnerHTML={{ __html: renderedLatex }}
                  className="rendered-content block-latex"
                />
              );
            } catch (error) {
              console.error("Block LaTeX rendering error:", error);
              return <div key={index} className="error-content">{part}</div>;
            }
          }

          if (part.startsWith("$") && part.endsWith("$")) {
            const latex = part.slice(1, -1);
            try {
              const renderedLatex = katex.renderToString(latex, {
                displayMode: false,
              });
              return (
                <span
                  key={index}
                  dangerouslySetInnerHTML={{ __html: renderedLatex }}
                  className="rendered-content inline-latex"
                />
              );
            } catch (error) {
              console.error("Inline LaTeX rendering error:", error);
              return <span key={index} className="error-content">{part}</span>;
            }
          }

          try {
            const formattedContent = part.replace(/\n/g, "<br />");
          const allowedTags = [
  "b", "i", "em", "strong", "u", "sub", "sup", "span", "br", "ol", "ul", "li", "p", "img", "a", "blockquote", "code", "pre"
];
const allowedAttributes = {
  "*": ["style", "class", "id"],
  img: ["src", "alt"],
  a: ["href", "target"],
  span: ["style", "class"],
  p: ["style"],
  ul: ["style", "class"],
  li: ["style", "class"],
};

            const sanitizedContent = sanitizeHtml(formattedContent, {
              allowedTags,
              allowedAttributes,
              transformTags: {
                p: "span",
                div: "span",
              },
            });

            return (
              <span
                key={index}
                dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                className="rendered-content inline-text"
              />
            );
          } catch (error) {
            console.error("HTML rendering error:", error);
            return <span key={index} className="error-content">{part}</span>;
          }
        })}
      </div>
    );
  };

  const renderQuestionWithBlanks = (questionText, answers, isEditable = true) => {
    const parts = questionText.split("[BLANK]");
    const blanks = parts.slice(1).map((_, index) => (
      <input
        key={index}
        type="text"
        value={answers[index] || ""}
        onChange={(e) => isEditable && handleAnswerChange(index, e.target.value)}
        placeholder={`Answer ${index + 1}`}
        disabled={!isEditable}
        style={{
          display: "inline-block",
          width: "120px",
          minWidth: "80px",
          margin: "0 8px",
          padding: "8px 12px",
          border: `2px solid #0277bd`,
          borderRadius: "8px",
          backgroundColor: isEditable ? "#e3f2fd" : "#eceff1",
          color: "#333",
          fontSize: "16px",
          fontFamily: "'Roboto', sans-serif",
          boxShadow: isEditable ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none",
          transition: "all 0.2s ease",
          outline: "none",
          verticalAlign: "middle",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "pre-wrap",
        }}
        onMouseEnter={(e) =>
          isEditable && (e.target.style.boxShadow = "0 4px 8px rgba(2, 119, 189, 0.2)")
        }
        onMouseLeave={(e) =>
          isEditable && (e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)")
        }
        onFocus={(e) => {
          if (isEditable) {
            e.target.style.borderColor = "#01579b";
            e.target.style.transform = "scale(1.05)";
            e.target.style.backgroundColor = "#ffffff";
          }
        }}
        onBlur={(e) => {
          if (isEditable) {
            e.target.style.borderColor = "#0277bd";
            e.target.style.transform = "scale(1)";
            e.target.style.backgroundColor = "#e3f2fd";
          }
        }}
        onPaste={(e) => e.preventDefault()} // Block paste
        onContextMenu={(e) => e.preventDefault()} // Disable right-click
      />
    ));

    return (
      <span style={{ display: "inline-flex", alignItems: "baseline", whiteSpace: "normal" }}>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            <span style={{ display: "inline", whiteSpace: "normal" }}>
              {renderContent(part)}
            </span>
            {index < parts.length - 1 && blanks[index]}
          </React.Fragment>
        ))}
      </span>
    );
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* {(!quizStarted || isQuizFinished) && (
        <IconButton
          aria-label="history"
          onClick={toggleHistoryDrawer(true)}
          sx={{
            position: "fixed",
            top: 16,
            right: 80, // Adjusted to align with question icon position when shown
            zIndex: 10001, // Ensure it's above other elements but below drawer
             backgroundColor: darkMode ? "rgba(134, 133, 133, 0.8)" : "rgba(255, 255, 255, 0.8)",
            "&:hover": {
              backgroundColor: darkMode ? "rgba(145, 128, 128, 1)" : "rgba(255, 255, 255, 1)",
            },
          }}
        >
          <HistoryIcon />
        </IconButton>
      )} */}
      {quizStarted && !isQuizFinished && (
        <IconButton
          aria-label="questions"
          onClick={toggleQuestionList}
          sx={{
            position: "fixed",
            top: 16,
            right: 80, // Positioned before close icon
            zIndex: 10001, // Ensure it's above other elements but below drawer
            backgroundColor: mode === "dark" ? "rgba(134, 133, 133, 0.8)" : "rgba(255, 255, 255, 0.8)",
            "&:hover": {
              backgroundColor: mode === "dark" ? "rgba(145, 128, 128, 1)" : "rgba(255, 255, 255, 1)",
            },
          }}
        >
          <ListIcon />
        </IconButton>
      )}
      <IconButton
        aria-label="close quiz"
        onClick={handleCloseQuiz}
        sx={{
          position: "fixed",
          top: 16,
          right: 16,
          zIndex: 10001, // Ensure it's above other elements but below drawer
          backgroundColor: mode === "dark" ? "rgba(134, 133, 133, 0.8)" : "rgba(255, 255, 255, 0.8)",
          "&:hover": {
            backgroundColor: mode === "dark" ? "rgba(145, 128, 128, 1)" : "rgba(255, 255, 255, 1)",
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Question List Modal */}
      <Modal
        open={isQuestionListOpen}
        onClose={toggleQuestionList}
        aria-labelledby="question-list-modal"
        sx={{ zIndex: 10001 }}
      >
        <Fade in={isQuestionListOpen}>
          <MuiBox
            sx={{
              position: "fixed",
              top: 64,
              right: 80,
              width: { xs: "80%", sm: 300 },
              bgcolor: "white",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
              p: { xs: 2, sm: 3 },
              background: mode === "dark" ? "linear-gradient(145deg, #212121, #424242)" : mode === "custom" ? customColors.background : "linear-gradient(145deg, #ffffff, #f0f4f8)",
              maxHeight: "60vh",
              overflowY: "auto",
            }}
          >
            <Typography
              id="question-list-modal"
              variant="h6"
              sx={{
                fontWeight: 600,
                color:mode === "dark" ? "#fff" :mode === "custom" ? customColors.text : "#0277bd",
                mb: 2,
                textAlign: "center",
              }}
            >
              Question List
            </Typography>
            <MuiBox
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(40px, 1fr))",
                gap: 1,
                justifyItems: "center",
                mb: 2,
              }}
            >
              {questions.map((_, index) => {
                const isAttempted = allAnswers[index] && allAnswers[index].trim() !== "";
                const isSkipped = skippedQuestions.has(index);
                return (
                  <MuiBox
                    key={index}
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor:
                        mode === "dark"
                          ? isAttempted
                            ? "#1b5e20" // dark green attempted
                            : isSkipped
                              ? "#4a1c1c" // dark red skipped
                              : "#2c2c2c" // dark neutral
                          : mode === "custom"
                            ? isAttempted
                              ? customColors.success || "#aefab4" // custom attempted
                              : isSkipped
                                ? customColors.error || "#f8bbc4" // custom skipped
                                : "#ffffff" // custom neutral
                            : isAttempted
                              ? "#aefab4" // light attempted
                              : isSkipped
                                ? "#f8bbc4" // light skipped
                                : "transparent", // light neutral                       

                      border: isAttempted || isSkipped ? "none" : "1px solid #b0bec5",
                      cursor: "pointer",
                      fontWeight: 500,
                      color:
                        mode === "dark"
                          ? isAttempted
                            ? "#65e76b" // dark attempted text
                            : isSkipped
                              ? "#fc6767" // dark skipped text
                              : "#E0E0E0" // dark neutral text
                          : mode === "custom"
                            ? "#000000" // ✅ always black in custom mode
                            : isAttempted
                              ? "#2e7d32" // light attempted text
                              : isSkipped
                                ? "#d32f2f" // light skipped text
                                : "#333",   // light neutral text


                      "&:hover": {
                        bgcolor:
                          mode === "dark"
                            ? isAttempted
                              ? "#376e3a" // dark green hover
                              : isSkipped
                                ? "#7F1D1D" // dark red hover
                                : "#333" // dark neutral hover
                            : mode === "custom"
                              ? isAttempted
                                ? customColors.successHover || "#d0eddb"
                                : isSkipped
                                  ? customColors.errorHover || "#ffccd5"
                                  : customColors.hover || "#f0f4f8"
                              : isAttempted
                                ? "#d0eddb" // light green hover
                                : isSkipped
                                  ? "#ffccd5" // light red hover
                                  : "#f0f4f8", // light neutral hover
                      },

                    }}
                    onClick={() => handleQuestionSelect(index)}
                  >
                    {index + 1}
                  </MuiBox>
                );
              })}
            </MuiBox>
            <MuiBox sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="outlined"
                sx={{
                   borderColor: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd",
                  color: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd",
                  borderRadius: "50px",
                  px: 4,
                  py: 1,
                  fontWeight: 600,
                  "&:hover": {
                    borderColor: "#01579b",
                    color: "#01579b",
                  },
                }}
                onClick={toggleQuestionList}
              >
                Close
              </Button>
            </MuiBox>
          </MuiBox>
        </Fade>
      </Modal>

      {/* History Drawer */}
      {/* <Drawer
        anchor="right"
        open={isHistoryOpen}
        onClose={toggleHistoryDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "80%", sm: 300 },
            bgcolor: darkMode ? "#3b3a3a" : "#f9fafb",
            p: 2,
            zIndex: 11000, // Keep high to ensure visibility
          },
        }}
      >
        <MuiBox sx={{ display: "flex", alignItems: "center", mb: 2, p: 2 }}>
          <HistoryIcon sx={{ color: "#0277bd", mr: 1 }} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#0277bd",
            }}
          >
            Quiz History
          </Typography>
        </MuiBox>
        <List>
          {quizIds.length > 0 ? (
            quizIds.map((qId) => (
              <React.Fragment key={qId}>
                <ListItem>
                  <ListItemText
                    primary={`Quiz ID: ${qId}`}
                    primaryTypographyProps={{ fontWeight: 600, color: "#0277bd" }}
                  />
                </ListItem>
                {quizHistory[qId]?.length > 0 ? (
                  quizHistory[qId].map((attempt, index) => (
                    <ListItem key={`${qId}-${attempt.attempt_no}`} disablePadding>
                      <ListItemButton onClick={() => handleSelectHistoryAttempt(qId, attempt)}>
                        <ListItemText
                          primary={`Attempt ${attempt.attempt_no}`}
                          secondary={
                            <>
                              <span>
                                Score: {formatPercentage(attempt.results.score_percentage)} | {attempt.results.result}
                              </span>
                              <br />
                              <span style={{ color: darkMode ? '#E0E0E0' : '#333' }}>
                                Date: {formatTimestamp(attempt.timestamp)}
                              </span>
                            </>
                          }
                          primaryTypographyProps={{ fontWeight: 500 }}
                          secondaryTypographyProps={{
                            color: attempt.results.result.toLowerCase() === "passed" ? "#2e7d32" : "#d32f2f",
                            component: "div",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))
                ) : (
                  <ListItem>
                    <ListItemText primary="No attempts available" />
                  </ListItem>
                )}
              </React.Fragment>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No quiz history available" />
            </ListItem>
          )}
        </List>
        <MuiBox sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={toggleHistoryDrawer(false)}
            sx={{
              width: "100%",
              borderColor: "#0277bd",
              color: "#0277bd",
              borderRadius: "50px",
            }}
          >
            Close
          </Button>
        </MuiBox>
      </Drawer> */}

      {/* History Detail Modal JSX */}
      {/* <Modal
        open={isHistoryModalOpen}
        onClose={handleCloseHistoryModal}
        aria-labelledby="history-modal-title"
        aria-describedby="history-modal-description"
        sx={{ zIndex: 11001 }}
      >
        <Fade in={isHistoryModalOpen}>
          <MuiBox
            className={`quiz-result ${darkMode ? "dark-mode" : "light-mode"}`}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 800 },
              bgcolor: "white",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
              p: { xs: 3, sm: 4 },
              // background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
              maxHeight: "80vh",
              overflowY: "auto",
              animation: "scaleIn 0.3s ease-out",
              "@keyframes scaleIn": {
                "0%": {
                  transform: "translate(-50%, -50%) scale(0.8)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translate(-50%, -50%) scale(1)",
                  opacity: 1,
                },
              },
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseHistoryModal}
              sx={{
                position: "sticky",
                top: 2, // Reduced to ensure it’s not clipped by padding
                right: 2, // Adjusted for right-side positioning
                float: "right", // Helps align to the right in the flow
                zIndex: 10001,
                backgroundColor: "rgba(255, 255, 255, 0.69)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.84)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
            <MuiBox
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 3,
                justifyContent: "center",
              }}
            >
              <TrophyIcon sx={{ fontSize: 40, color: "#0277bd", mr: 1 }} />
              <Typography
                id="history-modal-title"
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 700,
                  background: "linear-gradient(45deg, #0277bd, #01579b)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Attempt Details
              </Typography>
            </MuiBox>
            {error && (
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  bgcolor: "#ffebee",
                  borderRadius: "8px",
                  p: 2,
                  mb: 3,
                }}
              >
                <ErrorIcon sx={{ color: "#d32f2f", mr: 1 }} />
                <Typography sx={{ color: "#d32f2f" }}>{error}</Typography>
              </MuiBox>
            )}
            {selectedAttempt ? (
              <Fade in key={animateKey} timeout={300}>
                <MuiBox
                  className='quiz-result box'
                  sx={{
                    // bgcolor: "#f9fafb",
                    borderRadius: "12px",
                    p: 3,
                    boxShadow: darkMode ? "0 4px 12px rgba(233, 222, 222, 0.1)" : "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <MuiBox
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                      gap: 2,
                    }}
                  >
                    {(() => {
                      const historyResults = selectedAttempt.attempt.results;

                      // Calculate duration
                      let duration = "N/A";
                      if (
                        historyResults.started_at &&
                        historyResults.started_at !== "N/A" &&
                        historyResults.ended_at &&
                        historyResults.ended_at !== "N/A"
                      ) {
                        const startTime = new Date(historyResults.started_at);
                        const endTime = new Date(historyResults.ended_at);
                        const diffMs = endTime - startTime;

                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                        const parts = [];
                        if (hours > 0) parts.push(`${hours}h`);
                        if (minutes > 0) parts.push(`${minutes}m`);
                        if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);
                        duration = parts.join(" ");
                      }

                      const historyFields = [
                        {
                          label: "Total Questions",
                          value: historyResults.total_questions || "N/A",
                          icon: InfoIcon,
                        },
                        {
                          label: "Attempted Questions",
                          value: `${historyResults.attempted_questions ?? 0} out of ${historyResults.total_questions || "N/A"}`,
                          icon: CheckIcon,
                        },
                        {
                          label: "Correct Answers",
                          value: historyResults.correct_answers ?? "N/A",
                          icon: CorrectIcon,
                        },
                        {
                          label: "Wrong Answers",
                          value: historyResults.wrong_answers ?? "N/A",
                          icon: IncorrectIcon,
                        },
                        {
                          label: "Final Score",
                          value: `${historyResults.final_score ?? "N/A"} out of ${historyResults.total_questions || "N/A"}`,
                          icon: TrophyIcon,
                        },
                        {
                          label: "Score Percentage",
                          value: formatPercentage(historyResults.score_percentage),
                          icon: CheckIcon,
                        },
                        {
                          label: "Result",
                          value: `${historyResults.result ?? "N/A"}${historyResults.passing_percentage ? ` (Passing: ${formatPercentage(historyResults.passing_percentage)})` : ""}`,
                          icon: CheckIcon,
                          bgcolor: historyResults.result?.toLowerCase() === "passed" ? "#e8f5e9" : historyResults.result?.toLowerCase() === "failed" ? "#ffebee" : "#f0f4f8",
                          color: historyResults.result?.toLowerCase() === "passed" ? "#2e7d32" : historyResults.result?.toLowerCase() === "failed" ? "#d32f2f" : "#01579b",
                        },
                        {
                          label: "Started At",
                          value:
                            historyResults.started_at && historyResults.started_at !== "N/A"
                              ? new Date(historyResults.started_at).toLocaleString("en-US", {
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              : "N/A",
                          icon: TimeIcon,
                        },
                        {
                          label: "Ended At",
                          value:
                            historyResults.ended_at && historyResults.ended_at !== "N/A"
                              ? new Date(historyResults.ended_at).toLocaleString("en-US", {
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              : "N/A",
                          icon: TimeIcon,
                        },
                        {
                          label: "Duration",
                          value: duration,
                          icon: TimeIcon,
                        },
                      ];

                      // Render all fields without pagination
                      return historyFields.map((field, index) => (
                        <MuiBox
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 2,
                            bgcolor: field.bgcolor || "#e3f2fd",
                            borderRadius: "8px",
                            p: 1,
                            pr: 2,
                          }}
                        >
                          <field.icon
                            sx={{
                              color: field.color || "#0277bd",
                              mr: 1,
                            }}
                          />
                          <Typography
                            sx={{
                              fontWeight:
                                field.label === "Result" ||
                                  field.label === "Final Score" ||
                                  field.label === "Score Percentage"
                                  ? 600
                                  : 500,
                              color:
                                field.color ||
                                (field.label === "Result" ||
                                  field.label === "Final Score" ||
                                  field.label === "Score Percentage"
                                  ? "#01579b"
                                  : "#333"),
                            }}
                          >
                            <strong>{field.label}:</strong> {field.value}
                          </Typography>
                        </MuiBox>
                      ));
                    })()}
                  </MuiBox>
                </MuiBox>
              </Fade>
            ) : (
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  bgcolor: "#f0f4f8",
                  borderRadius: "8px",
                  p: 2,
                  mb: 3,
                }}
              >
                <InfoIcon sx={{ color: "#666", mr: 1 }} />
                <Typography sx={{ color: "#666" }}>
                  No results available.
                </Typography>
              </MuiBox>
            )}
            <MuiBox sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 3 }}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#0277bd",
                  color: "white",
                  borderRadius: "50px",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: "#01579b",
                    transform: "scale(1.05)",
                    transition: "all 0.2s",
                  },
                }}
                onClick={handleCloseHistoryModal}
              >
                Close
              </Button> */}
      {/* <Button
          variant="outlined"
          sx={{
            borderColor: "#0277bd",
            color: "#0277bd",
            borderRadius: "50px",
            px: 4,
            py: 1.5,
            fontWeight: 600,
            "&:hover": {
              borderColor: "#01579b",
              color: "#01579b",
              transform: "scale(1.05)",
              transition: "all 0.2s",
            },
          }}
          onClick={handleOpenHistoryReviewModal}
          disabled={!selectedAttempt || !selectedAttempt.attempt.answers || selectedAttempt.attempt.answers.length === 0}
        >
          Review Answers
        </Button> */}
      {/* </MuiBox>
          </MuiBox>
        </Fade>
      </Modal> */}

      {/* History Review Modal */}
      {/* <Modal
  open={isHistoryReviewModalOpen}
  aria-labelledby="history-review-modal"
  aria-describedby="history-review-details"
  sx={{ zIndex: 10000 }}
>
  <Fade in={isHistoryReviewModalOpen}>
    <MuiBox
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "90%", sm: 600 },
        bgcolor: "white",
        borderRadius: "16px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
        p: { xs: 3, sm: 4 },
        background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
        maxHeight: "80vh",
        overflowY: "auto",
        animation: "scaleIn 0.3s ease-out",
        "@keyframes scaleIn": {
          "0%": {
            transform: "translate(-50%, -50%) scale(0.8)",
            opacity: 0,
          },
          "100%": {
            transform: "translate(-50%, -50%) scale(1)",
            opacity: 1,
          },
        },
      }}
    >
       <IconButton
              aria-label="close"
              onClick={handleCloseHistoryReviewModal}
            sx={{
                position: "sticky",
                top: 2, // Reduced to ensure it’s not clipped by padding
                right: 2, // Adjusted for right-side positioning
                float: "right", // Helps align to the right in the flow
                zIndex: 10001,
                backgroundColor: "rgba(255, 255, 255, 0.69)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.84)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
      <MuiBox
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          justifyContent: "center",
        }}
      >
        <CheckIcon sx={{ fontSize: 40, color: "#0277bd", mr: 1 }} />
        <Typography
          id="history-review-modal"
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 700,
            background: "linear-gradient(45deg, #0277bd, #01579b)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Review Your Answers
        </Typography>
      </MuiBox>
      {questions.length > 0 && reviewAnswersFromHistory.length > 0 ? (
        questions.map((question, index) => {
          // Ensure the index doesn't exceed the length of reviewAnswersFromHistory
          if (index >= reviewAnswersFromHistory.length) {
            return null; // Skip rendering if no corresponding answer exists
          }
          const userAnswer = reviewAnswersFromHistory[index] || "Not answered";
          const isCorrect =
            userAnswer && userAnswer.trim().toLowerCase() ===
            question.answer.trim().toLowerCase();
          return (
            <MuiBox
              key={question.id}
              sx={{
                bgcolor: "#f9fafb",
                borderRadius: "12px",
                p: 3,
                mb: 3,
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#0277bd",
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Question {index + 1}
              </Typography>
              <MuiBox sx={{ mb: 2 }}>
                <Typography sx={{ fontWeight: 500, color: "#333" }}>
                  {renderContent(question.question)}
                </Typography>
              </MuiBox>
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  bgcolor: userAnswer === "Not answered" ? "#f0f4f8" : isCorrect ? "#e8f5e9" : "#ffebee",
                  borderRadius: "8px",
                  p: 1,
                }}
              >
                {userAnswer === "Not answered" ? (
                  <InfoIcon sx={{ color: "#666", mr: 1 }} />
                ) : isCorrect ? (
                  <CorrectIcon sx={{ color: "#2e7d32", mr: 1 }} />
                ) : (
                  <IncorrectIcon sx={{ color: "#d32f2f", mr: 1 }} />
                )}
                <Typography sx={{ fontWeight: 500, color: "#333" }}>
                  <strong>Your Answer:</strong> {userAnswer}
                </Typography>
              </MuiBox>
              <MuiBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <CorrectIcon sx={{ color: "#2e7d32", mr: 1 }} />
                <Typography sx={{ fontWeight: 500, color: "#333" }}>
                  <strong>Correct Answer:</strong>{" "}
                  {renderContent(question.answer)}
                </Typography>
              </MuiBox>
              {question.explanation && (
                <MuiBox sx={{ mb: 2 }}>
                  <Typography sx={{ fontWeight: 500, color: "#333" }}>
                    <strong>Explanation:</strong>{" "}
                    {renderContent(question.explanation)}
                  </Typography>
                </MuiBox>
              )}
            </MuiBox>
          );
        }).filter(Boolean)
      ) : (
        <MuiBox
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "#f0f4f8",
            borderRadius: "8px",
            p: 2,
            mb: 3,
          }}
        >
          <InfoIcon sx={{ color: "#666", mr: 1 }} />
          <Typography sx={{ color: "#666" }}>
            {questions.length === 0
              ? "No questions available to review."
              : "No answers available to review for this attempt."}
          </Typography>
        </MuiBox>
      )}
      <MuiBox sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#0277bd",
            color: "white",
            borderRadius: "50px",
            px: 4,
            py: 1.5,
            fontWeight: 600,
            "&:hover": {
              bgcolor: "#01579b",
              transform: "scale(1.05)",
              transition: "all 0.2s",
            },
          }}
          onClick={handleCloseHistoryReviewModal}
        >
          Back to History
        </Button>
      </MuiBox>
    </MuiBox>
  </Fade>
</Modal> */}
      <div
        className={`quiz-modal ${mode}-mode`}
        style={{
          minHeight: "100vh",
          // background: "linear-gradient(to bottom right, #e0f7fa, #b2ebf2)",
          padding: "40px 20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Start Quiz Modal */}
        <Modal
          open={isStartModalOpen && shouldShowStartModal}
          aria-labelledby="start-quiz-modal"
          aria-describedby="start-quiz-settings"
          sx={{ zIndex: 9999 }}
        >
          <Fade in={isStartModalOpen && shouldShowStartModal}>
            <MuiBox
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: 500 },
                bgcolor: "white",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                p: { xs: 3, sm: 4 },
                background: mode === "dark" ? "linear-gradient(145deg, #163642ff, #373d52ff)" : mode === "custom" ? customColors.background : "linear-gradient(145deg, #ffffff, #f0f4f8)",
                animation: "scaleIn 0.3s ease-out",
                "@keyframes scaleIn": {
                  "0%": {
                    transform: "translate(-50%, -50%) scale(0.8)",
                    opacity: 0,
                  },
                  "100%": {
                    transform: "translate(-50%, -50%) scale(1)",
                    opacity: 1,
                  },
                },
              }}
            >
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 3,
                  justifyContent: "center",
                }}
              >
                <CheckIcon sx={{ fontSize: 40, color: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd", mr: 1 }} />
                <Typography
                  id="start-quiz-modal"
                  variant="h5"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    background: mode == "dark" ? "linear-gradient(45deg, #0277bd, #01579b)" : mode === "custom" ? customColors.text : "linear-gradient(45deg, #0277bd, #01579b)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Quiz Settings
                </Typography>
              </MuiBox>
              <MuiBox sx={{ mb: 3 }}>
                <MuiBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <TextField
                    fullWidth
                    label="Max Attempts"
                    type="number"
                    value={maxAttempts}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty string or numbers >= 1
                      if (value === "" || (Number(value) >= 1 && Number.isInteger(Number(value)))) {
                        setMaxAttempts(value);
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color:
                          mode === "dark"
                            ? "#ffffff" // dark mode
                            : mode === "custom"
                              ? customColors.text // custom theme
                              : "#000000", // light mode
                      },
                    }}
                    placeholder="Leave blank for unlimited"
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "& fieldset": {
                          borderColor: "#b0bec5",
                        },
                        "&:hover fieldset": {
                          borderColor: "#0277bd",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#0277bd",
                        },
                      },
                    }}
                  />
                  <Tooltip
                    title="Set the maximum number of attempts allowed for the quiz. Leave blank for unlimited attempts."
                    placement="right"
                    arrow
                    PopperProps={{
                      style: { zIndex: 10000 },
                    }}
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        fontSize: "0.9rem",
                        bgcolor: "#0277bd",
                        color: "white",
                        borderRadius: "8px",
                        p: 1.5,
                      },
                      "& .MuiTooltip-arrow": {
                        color: "#0277bd",
                      },
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ marginLeft: "8px", cursor: "pointer" }}
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 16v.01" />
                      <path d="M12 8v4" />
                    </svg>
                  </Tooltip>
                </MuiBox>
                <MuiBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <TextField
                    fullWidth
                    label="Passing Percentage"
                    type="number"
                    value={passingPercentage}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty string or numbers >= 1 and <= 100
                      if (value === "" || (Number(value) >= 1 && Number(value) <= 100)) {
                        setPassingPercentage(value);
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color:
                          mode === "dark"
                            ? "#ffffff" // dark mode
                            : mode === "custom"
                              ? customColors.text // custom theme
                              : "#000000", // light mode
                      },
                    }}
                    placeholder="Enter percentage (defaults to 35)"
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "& fieldset": {
                          borderColor: "#b0bec5",
                        },
                        "&:hover fieldset": {
                          borderColor: "#0277bd",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#0277bd",
                        },
                      },
                    }}
                  />
                  <Tooltip
                    title="Set the minimum percentage required to pass the quiz (1-100). Defaults to 35% if not specified."
                    placement="right"
                    arrow
                    PopperProps={{
                      style: { zIndex: 10000 },
                    }}
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        fontSize: "0.9rem",
                        bgcolor: "#0277bd",
                        color: "white",
                        borderRadius: "8px",
                        p: 1.5,
                      },
                      "& .MuiTooltip-arrow": {
                        color: "#0277bd",
                      },
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ marginLeft: "8px", cursor: "pointer" }}
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 16v.01" />
                      <path d="M12 8v4" />
                    </svg>
                  </Tooltip>
                </MuiBox>
                <MuiBox sx={{ display: "flex", alignItems: "center", mb: 2, flexWrap: "wrap" }}>
                  <FormControl component="fieldset" sx={{ flex: "0 0 auto", mr: 4 }}>
                    <MuiBox sx={{ display: "flex", alignItems: "center" }}>
                      <FormLabel component="legend" sx={{ color: mode === "dark" ? "white" : mode === "custom" ? customColors.text : negativeMarking ? "#fff" : "#333", mb: 1 }}>
                        Negative Marking
                      </FormLabel>
                      <Tooltip
                        title="Enable negative marking to deduct points for incorrect answers. If disabled, incorrect answers do not affect the score."
                        placement="left"
                        arrow
                        PopperProps={{
                          style: { zIndex: 10000 },
                        }}
                        sx={{
                          "& .MuiTooltip-tooltip": {
                            fontSize: "0.9rem",
                            bgcolor: "#0277bd",
                            color: "white",
                            borderRadius: "8px",
                            p: 1.5,
                          },
                          "& .MuiTooltip-arrow": {
                            color: "#0277bd",
                          },
                        }}
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd"}
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          style={{ marginLeft: "8px", marginBottom: "4px", cursor: "pointer", }}
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 16v.01" />
                          <path d="M12 8v4" />
                        </svg>
                      </Tooltip>
                    </MuiBox>
                    <RadioGroup
                      row
                      value={negativeMarking ? "yes" : "no"}
                      onChange={(e) => setNegativeMarking(e.target.value === "yes")}
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio sx={{ color:mode==="dark"? "#0277bd":mode==="custom"?customColors.text: "#0277bd" }} />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio sx={{ color:mode==="dark"? "#0277bd":mode==="custom"?customColors.text: "#0277bd" }} />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl component="fieldset" sx={{ flex: "0 0 auto", marginLeft: 2 }}>
                    <MuiBox sx={{ display: "flex", alignItems: "center" }}>
                      <FormLabel component="legend" sx={{ color: mode === "dark" ? "white" : mode === "custom" ? customColors.text : negativeMarking ? "#fff" : "#333", mb: 1 }}>
                        Enable Timer
                      </FormLabel>
                      <Tooltip
                        title="Enable the timer to set a time limit for the quiz (30 seconds per question). Disable to take the quiz without a time constraint."
                        placement="right"
                        arrow
                        PopperProps={{
                          style: { zIndex: 10000 },
                        }}
                        sx={{
                          "& .MuiTooltip-tooltip": {
                            fontSize: "0.9rem",
                            bgcolor: "#0277bd",
                            color: "white",
                            borderRadius: "8px",
                            p: 1.5,
                          },
                          "& .MuiTooltip-arrow": {
                            color: "#0277bd",
                          },
                        }}
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd"}
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          style={{ marginLeft: "8px", marginBottom: "4px", cursor: "pointer", }}
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 16v.01" />
                          <path d="M12 8v4" />
                        </svg>
                      </Tooltip>
                    </MuiBox>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isTimerEnabled}
                          onChange={(e) => setIsTimerEnabled(e.target.checked)}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.bgColor : "#0277bd",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                              backgroundColor: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.bgColor : "#0277bd",
                            },
                          }}
                        />
                      }
                      label={isTimerEnabled ? "Timer Enabled" : "Timer Disabled"}
                    />
                  </FormControl>
                </MuiBox>
              </MuiBox>
              <MuiBox sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#0277bd",
                    color: "white",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      bgcolor: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleStartQuiz}
                >
                  Start Quiz
                </Button>
              </MuiBox>
            </MuiBox>
          </Fade>
        </Modal>
        {/* Result modal */}
        <Modal
          open={isResultModalOpen}
          aria-labelledby="result-modal"
          aria-describedby="result-details"
          sx={{
            zIndex: 1300,
            position: "fixed", // Ensure the modal is isolated
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Fade in={isResultModalOpen}>
            <MuiBox
              className={`quiz-result ${mode}-mode`}
              ref={modalRef}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: 800 },
                bgcolor: "white",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                p: { xs: 3, sm: 4 },
                // background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
                maxHeight: "80vh",
                overflowY: "auto",
                animation: "scaleIn 0.3s ease-out",
                "@keyframes scaleIn": {
                  "0%": {
                    transform: "translate(-50%, -50%) scale(0.8)",
                    opacity: 0,
                  },
                  "100%": {
                    transform: "translate(-50%, -50%) scale(1)",
                    opacity: 1,
                  },
                },
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleCloseResultModal}
                sx={{
                  position: "sticky",
                  top: 2, // Reduced to ensure it’s not clipped by padding
                  right: 2, // Adjusted for right-side positioning
                  float: "right", // Helps align to the right in the flow
                  zIndex: 10001,
                  backgroundColor: "rgba(255, 255, 255, 0.69)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.84)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 3,
                  justifyContent: "center",
                }}
              >
                <TrophyIcon sx={{ fontSize: 40, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd", mr: 1 }} />
                <Typography
                  id="result-modal"
                  variant="h5"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    background: mode === "dark" ? "linear-gradient(45deg, #0277bd, #01579b)" : mode === "custom" ? customColors.text : "linear-gradient(45deg, #0277bd, #01579b)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Quiz Results
                </Typography>
              </MuiBox>
              {error && (
                <MuiBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#ffebee",
                    borderRadius: "8px",
                    p: 2,
                    mb: 3,
                  }}
                >
                  <ErrorIcon sx={{ color: "#d32f2f", mr: 1 }} />
                  <Typography sx={{ color: "#d32f2f" }}>{error}</Typography>
                </MuiBox>
              )}
              {results ? (
                <Fade in key={animateKey} timeout={300}>
                  <MuiBox
                    className={`quiz-result-box ${mode}-mode`}
                    sx={{
                      // bgcolor: "#f9fafb",
                      borderRadius: "12px",
                      p: 3,
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333", mb: 1 }}>
                        Select Attempt
                      </Typography>
                      <Select
                        value={selectedAttemptNo ?? currentAttemptNo ?? ""}
                        onChange={handleAttemptChange}
                        size="small"
                        MenuProps={{
                          disablePortal: true,
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          PopperProps: {
                            placement: "bottom-start",
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, 4],
                                },
                              },
                              {
                                name: "preventOverflow",
                                options: {
                                  boundariesElement: "viewport",
                                },
                              },
                            ],
                          },
                          PaperProps: {
                            sx: {
                              zIndex: 10001,
                              maxHeight: 200,
                              width: 200,
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                              "& .MuiMenuItem-root": {
                                fontSize: "0.875rem",
                                padding: "6px 12px",
                                "&:hover": {
                                  backgroundColor: "#e3f2fd",
                                },
                              },
                            },
                          },
                        }}
                        sx={{
                          borderRadius: "8px",
                          maxWidth: 200,
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0bec5",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#0277bd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#0277bd",
                          },
                          "& .MuiSelect-select": {
                            padding: "6px 26px 6px 12px",
                            fontSize: "0.875rem",
                          },
                        }}
                      >
                        {attempts.length > 0 ? (
                          attempts.map((attempt) => (
                            <MenuItem key={attempt.attempt_no} value={attempt.attempt_no}>
                              Attempt {attempt.attempt_no}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="" disabled>
                            No attempts available
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    <MuiBox
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                        gap: 2,
                      }}
                    >
                      {resultFields
                        .slice(
                          (currentPage - 1) * itemsPerPage,
                          currentPage * itemsPerPage
                        )
                        .map((field, index) => (
                          <MuiBox
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                              bgcolor: field.bgcolor || "#e3f2fd",
                              borderRadius: "8px",
                              p: 1,
                              pr: 2,
                            }}
                          >
                            <field.icon
                              sx={{
                                color: field.color || "#0277bd",
                                mr: 1,
                              }}
                            />
                            <Typography
                              sx={{
                                fontWeight:
                                  field.label === "Result" ||
                                    field.label === "Final Score" ||
                                    field.label === "Score Percentage"
                                    ? 600
                                    : 500,
                                color:
                                  field.color ||
                                  (field.label === "Result" ||
                                    field.label === "Final Score" ||
                                    field.label === "Score Percentage"
                                    ? "#01579b"
                                    : "#333"),
                              }}
                            >
                              <strong>{field.label}:</strong> {field.value}
                            </Typography>
                          </MuiBox>
                        ))}
                    </MuiBox>
                    {totalPages > 1 && (
                      <MuiBox
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 3,
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            borderColor: "#0277bd",
                            color: "#0277bd",
                            borderRadius: "50px",
                            px: 3,
                            py: 1,
                            "&:hover": {
                              borderColor: "#01579b",
                              color: "#01579b",
                            },
                            "&.Mui-disabled": {
                              borderColor: "#b0bec5",
                              color: "#b0bec5",
                            },
                          }}
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </Button>
                        <Typography sx={{ fontWeight: 500 }}>
                          Page {currentPage} of {totalPages}
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            borderColor: "#0277bd",
                            color: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd",
                            borderRadius: "50px",
                            px: 3,
                            py: 1,
                            "&:hover": {
                              borderColor: "#01579b",
                              color: "#01579b",
                            },
                            "&.Mui-disabled": {
                              borderColor: "#b0bec5",
                              color: "#b0bec5",
                            },
                          }}
                          onClick={handleNextPage}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </Button>
                      </MuiBox>
                    )}
                  </MuiBox>
                </Fade>
              ) : (
                <MuiBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#f0f4f8",
                    borderRadius: "8px",
                    p: 2,
                    mb: 3,
                  }}
                >
                  <InfoIcon sx={{ color: "#666", mr: 1 }} />
                  <Typography sx={{ color: "#666" }}>
                    No results available.
                  </Typography>
                </MuiBox>
              )}
              <MuiBox sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#0277bd",
                    color: "white",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      bgcolor: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleCloseResultModal}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    borderColor: "#0277bd",
                    color: "#0277bd",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      borderColor: "#01579b",
                      color: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleOpenReviewModal}
                >
                  Review Answers
                </Button>
              </MuiBox>
            </MuiBox>
          </Fade>
        </Modal>
        {/* review Answer */}
        <Modal
          open={isReviewModalOpen}
          aria-labelledby="review-modal"
          aria-describedby="review-details"
          sx={{ zIndex: 10000 }}
        >
          <Fade in={isReviewModalOpen}>
            <MuiBox
              className={`quiz-result ${mode}-mode`}
              ref={reviewModalRef}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: 600 },
                bgcolor: "white",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                p: { xs: 3, sm: 4 },
                // background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
                maxHeight: "80vh",
                overflowY: "auto",
                animation: "scaleIn 0.3s ease-out",
                "@keyframes scaleIn": {
                  "0%": {
                    transform: "translate(-50%, -50%) scale(0.8)",
                    opacity: 0,
                  },
                  "100%": {
                    transform: "translate(-50%, -50%) scale(1)",
                    opacity: 1,
                  },
                },
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleCloseReviewModal}
                sx={{
                  position: "sticky",
                  top: 2, // Reduced to ensure it’s not clipped by padding
                  right: 2, // Adjusted for right-side positioning
                  float: "right", // Helps align to the right in the flow
                  zIndex: 10001,
                  backgroundColor: "rgba(255, 255, 255, 0.69)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.84)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 3,
                  justifyContent: "center",
                }}
              >
                <CheckIcon sx={{ fontSize: 40, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd", mr: 1 }} />
                <Typography
                  id="review-modal"
                  variant="h5"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    background: mode === "dark" ? "linear-gradient(45deg, #0277bd, #01579b)" : mode === "custom" ? customColors.text : "linear-gradient(45deg, #0277bd, #01579b)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Review Your Answers
                </Typography>
              </MuiBox>
              {questions.length > 0 ? (
                questions.map((question, index) => {
                  const userAnswer = allAnswers[index] || "";
                  const userAnswerArray = userAnswer ? userAnswer.split(",") : [];
                  const correctAnswer = question.answer || "";
                  const correctAnswerArray = correctAnswer ? correctAnswer.split(",") : [];
                  const isCorrect =
                    userAnswer.trim().toLowerCase() === correctAnswer.trim().toLowerCase();
                  console.log("Review check:", {
                    questionId: question.id,
                    userAnswer,
                    correctAnswer,
                    isCorrect,
                  });
                  return (
                    <MuiBox
                      className={`quiz-result ${mode}-mode`}
                      key={question.id}
                      sx={{
                        // bgcolor: "#f9fafb",
                        borderRadius: "12px",
                        p: 3,
                        mb: 3,
                        boxShadow: mode === "dark" ? "0 4px 12px rgba(243, 225, 225, 0.1)" : "0 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd",
                          mb: 2,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        Question {index + 1}
                      </Typography>
                      <MuiBox sx={{ mb: 2 }}>
                        <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333" }}>
                          {renderQuestionWithBlanks(question.question, userAnswerArray, false)}
                        </Typography>
                      </MuiBox>
                      <MuiBox
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2,
                          bgcolor: isCorrect ? "#e8f5e9" : "#ffebee",
                          borderRadius: "8px",
                          p: 1,
                        }}
                      >
                        {isCorrect ? (
                          <CorrectIcon sx={{ color: "#2e7d32", mr: 1 }} />
                        ) : (
                          <IncorrectIcon sx={{ color: "#d32f2f", mr: 1 }} />
                        )}
                        <Typography sx={{ fontWeight: 500, color: "#333" }}>
                          <strong>Your Answer:</strong> {userAnswer || "Not answered"}
                        </Typography>
                      </MuiBox>
                      <MuiBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                        <CorrectIcon sx={{ color: "#2e7d32", mr: 1 }} />
                        <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333" }}>
                          <strong>Correct Answer:</strong>{" "}
                          {renderContent(correctAnswer)}
                        </Typography>
                      </MuiBox>
                      {question.explanation && (
                        <MuiBox sx={{ mb: 2 }}>
                          <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333" }}>
                            <strong>Explanation:</strong>{" "}
                            {renderContent(question.explanation)}
                          </Typography>
                        </MuiBox>
                      )}
                    </MuiBox>
                  );
                })
              ) : (
                <MuiBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#f0f4f8",
                    borderRadius: "8px",
                    p: 2,
                    mb: 3,
                  }}
                >
                  <InfoIcon sx={{ color: "#666", mr: 1 }} />
                  <Typography sx={{ color: "#666" }}>
                    No answers available to review.
                  </Typography>
                </MuiBox>
              )}
              <MuiBox sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#0277bd",
                    color: "white",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      bgcolor: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleCloseReviewModal}
                >
                  Back to Results
                </Button>
              </MuiBox>
            </MuiBox>
          </Fade>
        </Modal>
        {/* Editable Review Answers */}
        <Modal
          open={isEditableReviewModalOpen}
          aria-labelledby="editable-review-modal"
          aria-describedby="editable-review-details"
          sx={{ zIndex: 10000 }}
        >
          <Fade in={isEditableReviewModalOpen}>
            <MuiBox
              className={`quiz-result ${mode}-mode`}
              ref={editableReviewModalRef}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: 600 },
                bgcolor: "white",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                p: { xs: 3, sm: 4 },
                // background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
                maxHeight: "80vh",
                overflowY: "auto",
                animation: "scaleIn 0.3s ease-out",
                "@keyframes scaleIn": {
                  "0%": {
                    transform: "translate(-50%, -50%) scale(0.8)",
                    opacity: 0,
                  },
                  "100%": {
                    transform: "translate(-50%, -50%) scale(1)",
                    opacity: 1,
                  },
                },
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleCloseEditableReviewModal}
                sx={{
                  position: "sticky",
                  top: 2, // Reduced to ensure it’s not clipped by padding
                  right: 2, // Adjusted for right-side positioning
                  float: "right", // Helps align to the right in the flow
                  zIndex: 10001,
                  backgroundColor: "rgba(255, 255, 255, 0.69)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.84)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 3,
                  justifyContent: "center",
                }}
              >
                <CheckIcon sx={{ fontSize: 40, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd", mr: 1 }} />
                <Typography
                  id="editable-review-modal"
                  variant="h5"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    background: mode === "dark" ? "linear-gradient(45deg, #0277bd, #01579b)" : mode === "custom" ? customColors.text : "linear-gradient(45deg, #0277bd, #01579b)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Review and Edit Your Answers
                </Typography>
              </MuiBox>
              {questions.length > 0 ? (
                questions.map((question, index) => {
                  const answerArray = allAnswers[index] ? allAnswers[index].split(",") : new Array(question.blankCount).fill("");
                  return (
                    <MuiBox
                      classNmae="quiz-result box"
                      key={question.id}
                      sx={{
                        // bgcolor: "#f9fafb",
                        borderRadius: "12px",
                        p: 3,
                        mb: 3,
                        boxShadow: mode === "dark" ? "0 4px 12px rgba(211, 205, 205, 0.1)" : "0 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd",
                          mb: 2,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        Question {index + 1}
                      </Typography>
                      <MuiBox sx={{ mb: 2 }}>
                        <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : "#333" }}>
                          {renderQuestionWithBlanks(question.question, answerArray, false)}
                        </Typography>
                      </MuiBox>
                      <MuiBox sx={{ mb: 2 }}>
                        <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333", mb: 1 }}>
                          <strong>Your Answers:</strong>
                        </Typography>
                        {Array.from({ length: question.blankCount }, (_, blankIndex) => (
                          <TextField
                            key={blankIndex}
                            fullWidth
                            value={answerArray[blankIndex] || ""}
                            onChange={(e) => handleAnswerEdit(index, blankIndex, e.target.value)}
                            placeholder={`Answer ${blankIndex + 1}`}
                            variant="outlined"
                            sx={{
                              mb: 1,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                "& fieldset": {
                                  borderColor: "#b0bec5",
                                },
                                "&:hover fieldset": {
                                  borderColor: "#0277bd",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#0277bd",
                                },
                              },
                            }}
                            onPaste={(e) => e.preventDefault()} // Block paste
                            onContextMenu={(e) => e.preventDefault()} // Disable right-click
                          />
                        ))}
                      </MuiBox>
                    </MuiBox>
                  );
                })
              ) : (
                <MuiBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#f0f4f8",
                    borderRadius: "8px",
                    p: 2,
                    mb: 3,
                  }}
                >
                  <InfoIcon sx={{ color: "#666", mr: 1 }} />
                  <Typography sx={{ color: "#666" }}>
                    No answers available to review.
                  </Typography>
                </MuiBox>
              )}
              <MuiBox sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#0277bd",
                    color: "white",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      bgcolor: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleSaveAndFinish}
                >
                  Save and Finish
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    borderColor: "#0277bd",
                    color: "white",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      borderColor: "#01579b",
                      color: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleCloseEditableReviewModal}
                >
                  Cancel
                </Button>
              </MuiBox>
            </MuiBox>
          </Fade>
        </Modal>
        {/* Timer Modal */}
        <Modal
          open={isTimeUpModalOpen}
          aria-labelledby="time-up-modal"
          aria-describedby="time-up-message"
          sx={{ zIndex: 9999 }}
        >
          <Fade in={isTimeUpModalOpen}>
            <MuiBox
              className={`quiz-modal ${mode}-mode`}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: 400 },
                bgcolor: "white",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                p: { xs: 3, sm: 4 },
                // background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
                animation: "scaleIn 0.3s ease-out",
                "@keyframes scaleIn": {
                  "0%": {
                    transform: "translate(-50%, -50%) scale(0.8)",
                    opacity: 0,
                  },
                  "100%": {
                    transform: "translate(-50%, -50%) scale(1)",
                    opacity: 1,
                  },
                },
              }}
            >
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 3,
                  justifyContent: "center",
                }}
              >
                <ErrorIcon sx={{ fontSize: 40, color: "#d32f2f", mr: 1 }} />
                <Typography
                  id="time-up-modal"
                  variant="h5"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    background: "linear-gradient(45deg, #d32f2f, #b71c1c)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Time's Up!
                </Typography>
              </MuiBox>
              <Typography sx={{ mb: 3, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333", textAlign: "center" }}>
                The quiz time has expired. Your answers have been submitted.
              </Typography>
              <MuiBox sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#0277bd",
                    color: "white",
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    "&:hover": {
                      bgcolor: "#01579b",
                      transform: "scale(1.05)",
                      transition: "all 0.2s",
                    },
                  }}
                  onClick={handleCloseModal}
                >
                  View Results
                </Button>
              </MuiBox>
            </MuiBox>
          </Fade>
        </Modal>
        {/* Confirmation closing dialog */}
        <Dialog
          open={isCloseDialogOpen}
          onClose={handleCancelClose}
          aria-labelledby="close-dialog-title"
          PaperProps={{
            sx: {
              borderRadius: "16px",           
            },
          }}
        >
          <DialogTitle id="close-dialog-title" sx={{ bgcolor: mode === "dark" ? "#333" : mode === "custom" ? customColors.background : "#fff" }}>Confirm Close</DialogTitle>
          <DialogContent sx={{ bgcolor: mode === "dark" ? "#333" : mode === "custom" ? customColors.background : "#fff" }}>
            <Typography>
              Are you sure you want to close the quiz? Your progress will be lost.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ bgcolor: mode === "dark" ? "#333" : mode === "custom" ? customColors.background : "#fff" }}>
            <Button onClick={handleCancelClose} variant="contained" color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmClose} variant="contained" color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        {/* Quiz screeen */}
        {!quizStarted && !isQuizFinished ? (
          <div
            style={{
              backgroundColor: mode === "dark" ? "#2c2c2c" : "#ffffff",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            Please configure quiz settings to start.
          </div>
        ) : !questions.length && !isQuizFinished ? (
          <div
            style={{
              backgroundColor: mode === "dark" ? "#2c2c2c" : mode === "custom" ? customColors.background : "#ffffff",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            Loading questions...
          </div>
        ) : isQuizFinished ? (
          <div
            className={`quiz-result ${mode}-mode`}
            style={{
              position: "relative", // Isolate the container
              overflow: "hidden", // Prevent overflow from affecting layout
              maxHeight: "500px", // Constrain the height (adjust as needed)
              // backgroundColor: "#ffffff",
              padding: "40px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
              maxWidth: "800px",
              width: "100%",
            }}
          >
            <MuiBox
              sx={{ display: "flex", alignItems: "center", mb: 3, justifyContent: "center" }}
            >
              <TrophyIcon sx={{ fontSize: 40, color: mode === "dark" ? "#0277bd" : mode === "custom" ? customColors.text : "#0277bd", mr: 1 }} />
              <Typography
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 700,
                  background: mode === "dark" ? "linear-gradient(45deg, #0277bd, #01579b)" : mode === "custom" ? customColors.text : "linear-gradient(45deg, #0277bd, #01579b)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Quiz Results
              </Typography>
            </MuiBox>
            {error ? (
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  bgcolor: "#ffebee",
                  borderRadius: "8px",
                  p: 2,
                  mb: 3,
                }}
              >
                <ErrorIcon sx={{ color: "#d32f2f", mr: 1 }} />
                <Typography sx={{ color: "#d32f2f" }}>{error}</Typography>
              </MuiBox>
            ) : results ? (
              <MuiBox
                className={`quiz-result-box ${mode}-mode`}
                sx={{
                  // bgcolor: "#f9fafb",
                  borderRadius: "12px",
                  p: 3,
                  boxShadow: mode === "dark" ? "0 4px 12px rgba(235, 226, 226, 0.1)" : "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
              >
                <MuiBox
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 2,
                  }}
                >
                  {resultFields.map((field, index) => (
                    <MuiBox
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 2,
                        bgcolor: field.bgcolor || "#e3f2fd",
                        borderRadius: "8px",
                        p: 1,
                        pr: 2,
                      }}
                    >
                      <field.icon
                        sx={{
                          color: field.color || "#0277bd",
                          mr: 1,
                        }}
                      />
                      <Typography
                        sx={{
                          fontWeight:
                            field.label === "Result" ||
                              field.label === "Final Score" ||
                              field.label === "Score Percentage"
                              ? 600
                              : 500,
                          color:
                            field.color ||
                            (field.label === "Result" ||
                              field.label === "Final Score" ||
                              field.label === "Score Percentage"
                              ? "#01579b"
                              : "#333"),
                        }}
                      >
                        <strong>{field.label}:</strong> {field.value}
                      </Typography>
                    </MuiBox>
                  ))}
                </MuiBox>
              </MuiBox>
            ) : (
              <MuiBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  bgcolor: "#f0f4f8",
                  borderRadius: "8px",
                  p: 2,
                  mb: 3,
                }}
              >
                <InfoIcon sx={{ color: "#666", mr: 1 }} />
                <Typography sx={{ color: "#666" }}>
                  No results available.
                </Typography>
              </MuiBox>
            )}
            <MuiBox sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 3 }}>
              <Button
                variant="outlined"
                sx={{
                  bgcolor: "#0277bd",
                  color: "white",
                  borderRadius: "50px",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: "#01579b",
                    transform: "scale(1.05)",
                    transition: "all 0.2s",
                  },
                }}
                onClick={handleRetryQuiz}
                disabled={
                  quizMaxAttempts !== null && attemptCount >= quizMaxAttempts
                }
              >
                Retry Quiz
              </Button>
              <Button
                variant="contained"
                sx={{
                  borderColor: "#0277bd",
                  color: "white",
                  borderRadius: "50px",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  "&:hover": {
                    borderColor: "#01579b",
                    color: "#01579b",
                    transform: "scale(1.05)",
                    transition: "all 0.2s",
                  },
                }}
                onClick={handleViewResult}
              >
                View Detailed Results
              </Button>
            </MuiBox>
          </div>
        ) : (
          /* Quiz Question Screen */
          <div
            style={{
              background: mode === "dark" ? "linear-gradient(145deg, #163642ff, #373d52ff)" : mode === "custom" ? customColors.background : "linear-gradient(145deg, #ffffff, #f0f4f8)",
              padding: "40px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              maxWidth: "800px",
              width: "100%",
            }}
          >
            <MuiBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  background: mode === "dark" ? "linear-gradient(45deg, #0277bd, #01579b)" : mode === "custom" ? customColors.text : "linear-gradient(45deg, #0277bd, #01579b)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Question {currentQuestionIndex + 1} of {questions.length}
              </Typography>
              <MuiBox sx={{ display: "flex", alignItems: "center" }}>
                <TimeIcon sx={{ color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd", mr: 1 }} />
                <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333" }}>
                  {isTimerEnabled ? `Time Left: ${formatTime(timeLeft)}` : "Timer Disabled"}
                </Typography>
              </MuiBox>
            </MuiBox>
            {questions[currentQuestionIndex] ? (
              <>
                <MuiBox sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: 500, color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#333" }}>
                    {renderQuestionWithBlanks(
                      questions[currentQuestionIndex].question,
                      userAnswers
                    )}
                  </Typography>
                </MuiBox>
                <MuiBox
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <MuiBox sx={{ display: "flex", gap: 2 }}>
                    <IconButton
                      sx={{
                        border: mode === "dark" ? "1px solid #0277bd" : mode === "custom" ? `1px solid ${customColors.text}` : "1px solid #0277bd",
                        color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd",
                        borderRadius: "50px",
                        p: 1.5,
                        "&:hover": {
                          borderColor: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#01579b",
                          color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#01579b",
                        },
                        "&.Mui-disabled": {
                          borderColor: "#b0bec5",
                          color: "#b0bec5",
                        },
                      }}
                      onClick={handlePreviousQuestion}
                      disabled={currentQuestionIndex === 0}
                    >
                      <ArrowBack />
                    </IconButton>
                    <IconButton
                      sx={{
                        border: mode === "dark" ? "1px solid #0277bd" : mode === "custom" ? `1px solid ${customColors.text}` : "1px solid #0277bd",
                        color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd",
                        borderRadius: "50px",
                        p: 1.5,
                        "&:hover": {
                          borderColor: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#01579b",
                          color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#01579b",
                        },
                        "&.Mui-disabled": {
                          borderColor: "#b0bec5",
                          color: "#b0bec5",
                        },
                      }}
                      onClick={handleNextQuestion}
                      disabled={currentQuestionIndex + 1 === questions.length}
                    >
                      <ArrowForward />
                    </IconButton>
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd",
                        color: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#0277bd",
                        borderRadius: "50px",
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                        "&:hover": {
                          borderColor: mode === "dark" ? "#fff" : mode === "custom" ? customColors.text : "#01579b",
                          color: mode === "dark" ? "#01579b" : mode === "custom" ? customColors.text : "#01579b",
                        },
                      }}
                      onClick={handleSkipQuestion}
                    >
                      Skip
                    </Button>
                  </MuiBox>
                  <MuiBox sx={{ display: "flex", gap: 2 }}>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#0277bd",
                        color: "white",
                        borderRadius: "50px",
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                        "&:hover": {
                          bgcolor: "#01579b",
                          transform: "scale(1.05)",
                          transition: "all 0.2s",
                        },
                      }}
                      onClick={handleReviewAnswers}
                    >
                      Review Answers
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#2e7d32",
                        color: "white",
                        borderRadius: "50px",
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                        "&:hover": {
                          bgcolor: "#1b5e20",
                          transform: "scale(1.05)",
                          transition: "all 0.2s",
                        },
                      }}
                      onClick={handleFinishQuiz}
                    >
                      Finish Quiz
                    </Button>
                  </MuiBox>
                </MuiBox>
              </>
            ) : (
              <Typography sx={{ color: "#666" }}>
                No question available.
              </Typography>
            )}
          </div>
        )}
      </div>
      {/* // New No Internet Modal */}
      <Modal
        open={isNoInternetModalOpen}
        onClose={() => setIsNoInternetModalOpen(false)}
        aria-labelledby="no-internet-modal"
        sx={{ zIndex: 9999 }}
      >
        <Fade in={isNoInternetModalOpen}>
          <MuiBox
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 400 },
              bgcolor: "white",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
              p: { xs: 3, sm: 4 },
              background: "linear-gradient(145deg, #ffffff, #f0f4f8)",
              animation: "scaleIn 0.3s ease-out",
              "@keyframes scaleIn": {
                "0%": {
                  transform: "translate(-50%, -50%) scale(0.8)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translate(-50%, -50%) scale(1)",
                  opacity: 1,
                },
              },
            }}
          >
            <MuiBox
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 3,
                justifyContent: "center",
              }}
            >
              <ErrorIcon sx={{ fontSize: 30, color: "#d32f2f", mr: 1 }} />
              <Typography
                id="no-internet-modal"
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 650,
                  background: "linear-gradient(45deg, #d32f2f, #b71c1c)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                No Internet Connection
              </Typography>
            </MuiBox>
            <Typography sx={{ mb: 3, color: "#333", textAlign: "center" }}>
              No internet connection. Your answers have been saved and will be submitted when you're back online.
            </Typography>
            {/* <MuiBox sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#0277bd",
            color: "white",
            borderRadius: "50px",
            px: 4,
            py: 1.5,
            fontWeight: 600,
            "&:hover": {
              bgcolor: "#01579b",
              transform: "scale(1.05)",
              transition: "all 0.2s",
            },
          }}
          onClick={() => setIsNoInternetModalOpen(false)}
        >
          OK
        </Button>
      </MuiBox> */}
          </MuiBox>
        </Fade>
      </Modal>
      {/* Confirmation Dialog */}
      
            <Dialog
              open={openConfirm}
              maxWidth="sm"
              fullWidth
              onClose={() => setOpenConfirm(false)}
            >
              <DialogTitle
                sx={{
                  backgroundColor:
                    mode === "dark"
                      ? "#424242"
                      : mode === "custom"
                        ? customColors.bgNav || "#ffffff"
                        : "#ffffff",
                }}
              >
                {unansweredCount > 0 ? "Unanswered Questions" : "Finish Quiz?"}
              </DialogTitle>
      
              {/* Close Icon */}
              <IconButton
                aria-label="close"
                onClick={() => setOpenConfirm(false)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  color:
                    mode === "dark"
                      ? "#f1f1f1"
                      : mode === "custom"
                        ? customColors.text || "#333"
                        : "#333",
                }}
              >
                <CloseIcon />
              </IconButton>
      
              <DialogContent
                sx={{
                  backgroundColor:
                    mode === "dark"
                      ? "#424242"
                      : mode === "custom"
                        ? customColors.bgNav || "#ffffff"
                        : "#ffffff",
                }}
              >
                {unansweredCount > 0 ? (
                  <Typography>
                    You still have <strong>{unansweredCount}</strong> unanswered
                    questions. Do you want to submit anyway?
                  </Typography>
                ) : (
                  <Typography>Are you sure you want to finish the quiz?</Typography>
                )}
              </DialogContent>
      
              <DialogActions
                sx={{
                  backgroundColor:
                    mode === "dark"
                      ? "#424242"
                      : mode === "custom"
                        ? customColors.bgNav || "#ffffff"
                        : "#ffffff",
                }}
              >
                <Button
                  onClick={() => setOpenConfirm(false)}
                  variant="outlined"
                  sx={{
                    color:
                      mode === "dark"
                        ? "#44a6e9"
                        : mode === "custom"
                          ? customColors.text || "#0277bd"
                          : "#0277bd",
                  }}
                >
                  No, Go Back
                </Button>
                <Button
                  onClick={handleConfirmSubmit}
                  color="primary"
                  variant="contained"
                >
                  Yes, Submit
                </Button>
              </DialogActions>
            </Dialog>
    </Box>
  );
};

export default FIBQuiz;